import React, { ReactNode, startTransition, useEffect, useState } from "react";
import {
  Row,
  Col,
  Divider,
  Form,
  Modal,
  Table,
  Image,
  Badge,
  Input,
  Tabs,
  Tag,
  Dropdown,
  Button as AntdButton,
  Checkbox,
  Typography,
  ConfigProvider,
  Card,
  Skeleton,
} from "antd";
import { CardContainer } from "../../components/Card/CardContainer";
import Button from "../../components/Button/Button";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import styled from "styled-components";
import { ProductEntity } from "../../entities/PoductEntity";
import {
  DetailBox as DetailBoxStyled,
  FlexCol,
  FlexRow,
} from "../../components/Container/Container";
import color from "../../resource/color";
import image from "../../resource/image";
import icons from "../../resource/icon";
import Text from "../../components/Text/Text";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PageSpin from "../../components/Spin/pageSpin";
import Select from "../../components/Select/Select";
import { numberFormatter, priceFormatter } from "../../utility/Formatter";
import {
  ORDER_PAYMENT_STATUS,
  ORDER_PAYMENT_METHOD_NAME,
  OrderStatusKey,
  OrderPaymentStatusKey,
  ORDER_DELIVERY_DEST_METHOD_NAME,
  getOrderStatusInfo,
} from "../../definitions/orderStatus";
import {
  addOrderCo,
  approveSoOrder,
  getCoAvailableById,
  getCoUsedById,
  getInvoices,
  getOrderDetail,
  getOrderDiscount,
  previewCoPercent,
  submitToNav,
  updateCoPercent,
  updateOrderStatus,
} from "../../datasource/OrderDatasourc";
import { OrderEntity } from "../../entities/OrderEntity";
import { getOrderStatus } from "../../utility/OrderStatus";
import Permission, { checkPermission } from "../../components/Permission/Permission";
import { FileItem } from "./orderComponent/fileItem";
import _, { set } from "lodash";
import { checkCompany } from "../../utility/CompanyName";
import Swal from "sweetalert2";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../store/RoleAtom";
import dayjs from "dayjs";

import "dayjs/locale/th";
import "dayjs/plugin/buddhistEra";
import { orderSubStatusColor, orderSubStatusLabel } from "../../definitions/invoice";
import axios, { AxiosRequestConfig } from "axios";
import { DoubleRowTitle } from "./orderComponent/title";
import {
  DownOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FormOutlined,
  LoadingOutlined,
  RightOutlined,
  UpOutlined,
} from "@ant-design/icons";
import EvidenceSection from "../CheckCreditPage/SettingCredit/EvidenceSection";
import { getSignImg } from "../../datasource/OverCreditApproveDatasource";
import type { SoApproversEntity } from "../../entities/SoApproversEntity";
import type { CreditApproversEntity } from "../../entities/CreditApproversEntity";
import { ActionBtn } from "../../components/Button/TableActionButton";
import { useMessageContext } from "../../context/MessageProvider";
import { useEffectOnce } from "react-use";
import { onInputNumberKeyPress } from "../../utility/validator";
import { icon } from "../../resource";

const { TextArea } = Input;

const DATE_FORMAT = "D MMM BBBB";
const datePattern = "DD/MM/YYYY";
type FixedType = "left" | "right" | boolean | undefined;

const DetailBox = styled(DetailBoxStyled)`
  padding: 10px;
  margin-top: 12px;

  background: ${color.background1};
  border: 1px solid ${color.background2};
  border-radius: 16px;
`;

const NavResponseBox = styled(CardContainer)`
  border-width: ${(props) => (props.color ? "1px 1px 1px 13px" : "0px")};
  border-style: solid;
  border-color: ${(props) => props.color};
`;

const PendingTag = styled(Tag)`
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  .anticon {
    transition: color 0.2s ease;
  }

  &:hover {
    color: ${color.primary};
    border-color: ${color.primary};
  }

  &:hover .anticon {
    color: ${color.primary};
  }
`;
const StyledTable = styled(Table)`
  .total-row > td {
    background-color: ${color.background1} !important;
  }
`;

const PendingNoteTag: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <PendingTag
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <img
        src={isHovered ? icons.pendingBoxBlue : icons.pendingBox}
        style={{ width: "14px", height: "14px" }}
      />
      <RightOutlined />
    </PendingTag>
  );
};

export const DetailItem = ({
  label,
  labelEn,
  value,
  alignRight,
  fontWeight,
  fontSize,
  color,
  style,
  leftSpan,
  fontFamily = "IBM Plex Sans Thai",
  isSkeleton = false,
}: {
  label: string;
  labelEn?: string;
  value: string | ReactNode;
  alignRight?: boolean;
  fontWeight?: 400 | 500 | 600 | 700;
  fontFamily?: "IBM Plex Sans Thai" | "Sarabun";
  fontSize?: 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 30 | 32 | 34 | 36 | 38 | 40 | 46 | 50;
  color?:
    | "primary"
    | "secondary"
    | "Text1"
    | "Text2"
    | "Text3"
    | "error"
    | "success"
    | "warning"
    | "white";
  style?: any;
  leftSpan?: number;
  isSkeleton?: boolean;
}) => {
  return (
    <Row gutter={16} style={{ margin: "10px 0px" }} justify={"space-between"} align='middle'>
      <Col span={leftSpan ? leftSpan : alignRight ? 14 : 9}>
        <Text fontFamily={fontFamily} fontWeight={fontWeight} fontSize={fontSize}>
          {label}
        </Text>
        <br />
        {labelEn && (
          <Text fontFamily={fontFamily} fontWeight={fontWeight} fontSize={fontSize} color='Text3'>
            ({labelEn})
          </Text>
        )}
      </Col>
      <Col span={leftSpan ? 24 - leftSpan : alignRight ? 10 : 15}>
        <>
          {isSkeleton ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Skeleton.Input active size='small' style={{ width: 120, height: 18 }} />
            </div>
          ) : (
            <FlexRow justify={alignRight ? "end" : "start"}>
              <Text
                fontFamily={fontFamily}
                fontWeight={fontWeight}
                color={color ? color : "Text2"}
                style={style}
              >
                {value || "-"}
              </Text>
            </FlexRow>
          )}
        </>
      </Col>
    </Row>
  );
};

const storageColumnKey = "order-detail-column";

const rawColumns = [
  {
    title: "ชื่อสินค้า",
    dataIndex: "productName",
    key: "productName",
    width: 360,
    render: (productName: string, product: ProductEntity, index: number) => {
      return {
        children: (
          <>
            <FlexRow align='center'>
              <div style={{ marginRight: 16 }}>
                <Image
                  src={product?.productImage || image.product_no_image}
                  style={{
                    width: "55px",
                    height: "55px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <FlexCol>
                <Text level={5}>{productName}</Text>
                <Text level={6} color='Text3'>
                  {product?.commonName}
                </Text>
              </FlexCol>
            </FlexRow>
          </>
        ),
      };
    },
  },
  {
    title: "ขนาด",
    dataIndex: "packSize",
    key: "packSize",
    width: 170,
    render: (packSize: string, product: ProductEntity, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5}>{packSize}</Text>
            <Text level={6} color='Text3'>
              {product?.productCodeNAV || product?.productFreebiesCodeNAV}
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "จำนวน",
    dataIndex: "quantity",
    key: "quantity",
    width: 125,
    render: (quantity: string, product: ProductEntity, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5}>{Number(quantity).toFixed(2)}</Text>
            <Text level={6} color='Text3'>
              {product?.baseUnitOfMeaTh || product?.saleUOMTH || product?.saleUOM}
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "ราคา/หน่วย",
    dataIndex: "marketPrice",
    key: "marketPrice",
    width: 160,
    render: (marketPrice: number, product: ProductEntity, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5}>{priceFormatter(marketPrice || "0", undefined, false, true)}</Text>
            <Text level={6} color='Text3'>
              {" บาท / " + (product?.saleUOMTH || product?.saleUOM || product?.saleUom || "หน่วย")}
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "โปรโมชัน",
    dataIndex: "orderProductPromotions",
    key: "orderProductPromotions",
    width: 160,
    render: (orderProductPromotions: any[], product: any, index: number) => {
      const findPromotion = () => {
        let promotion = "";
        if (product?.orderProductPromotions?.length) {
          const p: any = [];
          for (let i = 0; product?.orderProductPromotions?.length > i; i++) {
            p.push(product?.orderProductPromotions[i].promotionCode);
          }
          promotion = p.map((a: any) => a).join(", ");
        } else {
          promotion = product?.productPromotionCode;
        }
        return promotion || "-";
      };
      return {
        children: (
          <FlexCol>
            <Text key={index} level={5}>
              {findPromotion()}
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "วันกำหนดชำระ",
    dataIndex: "dueDate",
    key: "dueDate",
    width: 160,
    render: (dueDate: number, product: any, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5}>
              {dueDate ? dayjs(dueDate).locale("th").format("D MMM BBBB") : "-"}
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "ส่วนลดรายการ",
    title2: "/หน่วย",
    dataIndex: "discount",
    key: "discountPerUnit",
    // fixed: "right" as FixedType,
    width: 160,
    render: (discount: number, product: any, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5} color={discount ? "error" : "Text3"} fontWeight={700}>
              {discount ? "- " + priceFormatter(discount || "0", undefined, false, true) : "-"}
            </Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "ส่วนลดโควตา",
    title2: "/หน่วย",
    dataIndex: "quotaDiscount",
    key: "quotaDiscount",
    // fixed: "right" as FixedType,
    width: 150,
    render: (discount: number, product: any, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5} color={discount ? "error" : "Text3"} fontWeight={700}>
              {discount ? "- " + priceFormatter(discount || "0", undefined, false, true) : "-"}
            </Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "ส่วนลด CO",
    title2: "/หน่วย",
    dataIndex: "coDiscount",
    key: "discountPerUnit",
    // fixed: "right" as FixedType,
    width: 150,
    render: (discount: number, product: any, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text
              level={5}
              color={discount || product?.coDiscount ? "error" : "Text3"}
              fontWeight={700}
            >
              {product?.coDiscount
                ? "- " + priceFormatter(product?.coDiscount || "0", undefined, false, true)
                : "-"}
            </Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "ส่วนลดรวม",
    dataIndex: "totalDiscount",
    key: "totalDiscount",
    // fixed: "right" as FixedType,
    width: 160,
    render: (totalDiscount: number, product: any, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5} color={totalDiscount ? "error" : "Text3"} fontWeight={700}>
              {totalDiscount
                ? "- " + priceFormatter(totalDiscount || "0", undefined, false, true)
                : "-"}
            </Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "Special REQ.",
    title2: "/หน่วย",
    dataIndex: "specialRequestDiscount",
    key: "specialRequestDiscountPerUnit",
    width: 160,
    // fixed: "right" as FixedType,
    render: (discount: number, product: any, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5} color={discount ? "purple" : "Text3"} fontWeight={700}>
              {discount
                ? "- " + priceFormatter(discount / product.quantity || "0", undefined, false, true)
                : "-"}
            </Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "Special REQ.",
    title2: "รวม",
    bottomSize: 16,
    dataIndex: "specialRequestDiscount",
    key: "specialRequestDiscount",
    width: 160,
    render: (discount: number, product: ProductEntity, index: number) => {
      return {
        children: (
          <FlexCol>
            <Text level={5} color={discount ? "purple" : "Text3"} fontWeight={700}>
              {discount ? "- " + priceFormatter(discount || "0", undefined, false, true) : "-"}
            </Text>
            <Text level={6} color='Text3'>
              บาท
            </Text>
          </FlexCol>
        ),
      };
    },
  },
  {
    title: "ราคารวม",
    title2: "ก่อนหักส่วนลด",
    bottomSize: 16,
    dataIndex: "price",
    key: "price",
    width: 180,
    fixed: "right" as FixedType,
    render: (price: number, product: ProductEntity, index: number) => {
      return {
        children: (
          <>
            {product?.isFreebie && !product?.isSpecialRequestFreebie && (
              <div style={{ position: "relative", bottom: 26, right: -10 }}>
                <Badge.Ribbon text='ของแถม' placement='end' />
              </div>
            )}
            {product?.isFreebie && product?.isSpecialRequestFreebie && (
              <div style={{ position: "relative", bottom: 26, right: -10 }}>
                <Badge.Ribbon text='ของแถม' placement='end' color={color.error} />
              </div>
            )}
            <FlexCol>
              <Text level={5} color='primary' fontWeight={700}>
                {priceFormatter(price || "0", undefined, false, true)}
              </Text>
              <Text level={6} color='Text3'>
                {"บาท"}
              </Text>
            </FlexCol>
          </>
        ),
      };
    },
  },
];

export const OrderDetail: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const roleData = useRecoilValue(roleAtom);
  const { company, firstname, lastname, docType } = userProfile;
  const userCompany = JSON.parse(localStorage.getItem("company")!);

  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const path = pathSplit[1];
  const id = pathSplit[2];

  const isViewMode = path === "view-order";
  const isSpecialRequestMode = path === "special-request";
  const isShowPrice = checkPermission(["orderList", "showPrice"], roleData);
  const [isApproveSo, setIsApproveSo] = useState(false);

  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState<OrderEntity>();
  const [invoices, setInvoices] = useState([]);
  const [updating, setUpdating] = useState(false);
  const [showCancelModal, setCancelModal] = useState(false);
  const [showApproveSqModal, setApproveSqModal] = useState(false);
  const [navSubmitStatus, setNavSubmitStatus] = useState<"success" | "wait" | "failed">("wait");
  const [navSubmitBody, setNavSubmitBody] = useState<any>();
  const [showFile, setShowFile] = useState(false);
  const [showFileDelivery, setShowFileDelivery] = useState(false);
  const [tab, setTab] = useState<string>("product");
  const [visibleColumns, setVisibleColumns] = useState<string[]>(rawColumns.map((c) => c.key));
  const [orderSoApprovers, setOrderSoApprovers] = useState<SoApproversEntity[]>([]);
  const [orderCreditApprovers, setOrderCreditApprovers] = useState<CreditApproversEntity[]>([]);
  const [form] = Form.useForm();
  const [navForm] = Form.useForm();
  const [showApproveSoModal, setShowApproveSoModal] = useState(false);

  const mapTruckType: any = {
    DOUBLE_TRUCK: "รถพ่วง",
    SINGLE_TRUCK: "รถเดี่ยว",
  };

  const hideForICPL = company === "ICPL" && process.env.REACT_APP_NODE_ENV !== "development";
  const isDevelopment = !hideForICPL;
  const cancelRemark = Form.useWatch("cancelRemark", form);

  const [modalCo, setModalCo] = useState<{ open: boolean; key: number; value: string }>({
    open: false,
    key: 0,
    value: "",
  });
  const [editCoList, setEditCoList] = useState<any[]>([]);
  const [modalEditPctCo, setModalEditPctCo] = useState<{
    open: boolean;
    action: string;
    value: any;
  }>({
    open: false,
    action: "",
    value: {},
  });
  const [editCoRemarkPct, setEditCoRemarkPct] = useState<string>("");
  const [coList, setCoList] = useState<any[]>([]);

  const fetchData = async () => {
    setLoading(true);
    const coEditList: any = await getCoUsedById(id).then((res) => {
      setEditCoRemarkPct(res.latestEditRemark || res.latestBillPctRemark);
      return res?.cos;
    });
    setEditCoList(coEditList);
    await getOrderDetail(id, true)
      .then(async (res: OrderEntity) => {
        form.setFieldValue(
          "reasonApproveSo",
          res?.orderSoApprovers && res.orderSoApprovers.length > 0
            ? res.orderSoApprovers[0]?.reason || ""
            : "",
        );
        setIsApproveSo(
          res?.orderSoApprovers?.find((x) => x.userStaffId == userProfile.userStaffId) !== undefined
            ? true
            : false,
        );
        const mapOrderProduct: any = [];
        await res?.orderProducts?.map((op: any, i: number) => {
          if (op.promotionQuotaQuantity !== 0) {
            const checkCompare = op.promotionQuotaQuantity !== op.quantity;
            if (checkCompare) {
              const baseQty = op.quantity - op.promotionQuotaQuantity;
              const promoQty = op.promotionQuotaQuantity;
              const baseDiscount = op.discount - op.promotionQuotaDiscount;
              const baseDiscountPerUnit = op.quantity > 0 ? baseDiscount / op.quantity : 0;
              const promoDiscountPerUnit = promoQty > 0 ? op.promotionQuotaDiscount / promoQty : 0;
              for (let j = 0; j < 2; j++) {
                const isBase = j === 0;
                const qty = isBase ? baseQty : promoQty;
                const discount = isBase
                  ? baseDiscountPerUnit
                  : promoDiscountPerUnit + baseDiscountPerUnit;
                const totalDiscount =
                  (discount + op.coDiscount / op.quantity + op.quotaDiscount / op.quantity) * qty;
                const price = op.marketPrice * qty;
                const orderProductPromotions = isBase
                  ? op.orderProductPromotions?.filter(
                      (opp) =>
                        opp.promotionType !== "DISCOUNT_NOT_MIX_SET" &&
                        opp.promotionType !== "DISCOUNT_MIX_RANGE",
                    ) || []
                  : op.orderProductPromotions;
                const specialRequestDiscount = op.specialRequest * qty;
                mapOrderProduct.push({
                  ...op,
                  quantity: qty,
                  discount,
                  totalDiscount,
                  price,
                  orderProductPromotions,
                  specialRequestDiscount,
                  coDiscount: op.coDiscount / op.quantity,
                  quotaDiscount: op.quotaDiscount / op.quantity || 0,
                  rowKey: `${op.productId}-${i + 1}-${j + 1}`,
                });
              }
            } else {
              mapOrderProduct.push({
                ...op,
                discount: op.discount / op.quantity || 0,
                totalDiscount: op.discount + op.quotaDiscount + op.coDiscount || 0,
                quotaDiscount: op.quotaDiscount / op.quantity || 0,
                coDiscount: op.coDiscount / op.quantity,
                rowKey: `${op.productId}-${i + 1}`,
              });
            }
          } else {
            mapOrderProduct.push({
              ...op,
              discount: op.discount / op.quantity || 0,
              totalDiscount: op.discount + op.quotaDiscount + op.coDiscount || 0,
              quotaDiscount: op.quotaDiscount / op.quantity || 0,
              coDiscount: op.coDiscount / op.quantity,
              rowKey: `${op.productId}-${i + 1}`,
            });
          }
        });

        const mapProduct: any = mapOrderProduct?.map((product, index) => {
          const findCo = coEditList?.filter((co) =>
            co.products.some((p) => `${p.productId}` === `${product.productId}`),
          );
          if (findCo?.length > 0) {
            return {
              ...product,
              editCoList: findCo?.map((co) => ({
                ...co,
                products: co.products
                  .map((p) => ({
                    ...p,
                    lines: p.lines.map((l) => ({
                      ...l,
                      saleUOMTH: product.saleUOMTH,
                      productId: product.productId,
                    })),
                  }))
                  .find((p) => `${p.productId}` === `${product.productId}`),
              })),
            };
          } else {
            return {
              ...product,
              editCoList: [],
            };
          }
        });
        setOrderData({ ...res, orderProducts: mapProduct, orderPending: res?.orderProducts });
        if (res?.soNo) {
          await getInvoices({ soNo: res?.soNo, company: userCompany.companyCode })
            .then((resInv) => {
              setInvoices(resInv);
            })
            .catch((e: any) => {
              console.log("invoices error : ", e);
            });
        }

        const getOrderApprover = (soApprovers: SoApproversEntity[]) => {
          const approved = soApprovers.find((a) => a.action !== "PENDING");
          if (approved) return [approved];

          const firstSequenceRequired = soApprovers.find((a) => a.sequenceRequired === 1);
          return firstSequenceRequired ? [firstSequenceRequired] : [];
        };

        const approvers = {
          credit: res.orderCreditApprovers || [],
          order: getOrderApprover(res.orderSoApprovers || []),
          specialRequest: res.userStaffId || [],
        };

        if (approvers.credit.length || approvers.order.length) {
          const [imgsCredit, imgsOrder] = await Promise.all([
            getSignImg({ userStaffIds: approvers.credit.map((a) => a.userStaffId) }),
            getSignImg({ userStaffIds: approvers.order.map((a) => a.userStaffId) }),
            getSignImg({ userStaffIds: [approvers.specialRequest] }),
          ]);

          const mapApprovers = (arr: any[], imgs: any[]) =>
            arr.map((a) => ({
              ...a,
              signImageUrl:
                imgs.find((img) => img.userStaffId === a.userStaffId)?.signImageUrl || null,
            }));

          setOrderCreditApprovers(mapApprovers(approvers.credit, imgsCredit));
          setOrderSoApprovers(mapApprovers(approvers.order, imgsOrder));
        }
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(async () => {
        setLoading(false);
      });
  };

  const fetchCoAvalibleList = async () => {
    await getCoAvailableById(id).then((res) => {
      const mapChecked = (res.cos || []).map((co: any) => {
        return { ...co, checked: false };
      });
      setCoList(mapChecked || []);
    });
  };

  useEffect(() => {
    if (!loading) {
      fetchData();
      fetchCoAvalibleList();
    }

    const storedColumns = JSON.parse(localStorage.getItem(storageColumnKey) || "[]");
    if (storedColumns && storedColumns.length) {
      setVisibleColumns(storedColumns);
    } else {
      const hidden =
        company === "ICPL"
          ? ["quotaDiscount"]
          : ["specialRequestDiscountPerUnit", "specialRequestDiscount"];
      setVisibleColumns(rawColumns.map((c) => c.key).filter((c) => !hidden.includes(c)));
    }
  }, []);

  const onSubmitStatus = async ({
    status,
    paidStatus,
    cancelRemark,
    reason,
  }: {
    status: OrderStatusKey;
    paidStatus?: OrderPaymentStatusKey;
    cancelRemark?: string;
    reason?: string;
  }) => {
    setUpdating(true);
    const id = pathSplit[2];
    await updateOrderStatus({
      orderId: id,
      status,
      paidStatus,
      cancelRemark,
      updateBy: `${firstname} ${lastname}`,
      reason,
    })
      .then((res: any) => {
        navigate(0);
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const updateStatus = async (nextStatus?: OrderStatusKey) => {
    const { status, paidStatus } = form.getFieldsValue();
    if (status === orderData?.status && paidStatus === orderData?.paidStatus) {
      Modal.error({
        title: "สถานะไม่มีการเปลี่ยนแปลง กรุณาตรวจสอบอีกครั้ง",
      });
      return;
    }
    Modal.confirm({
      title: `ยืนยันการปรับสถานะ "${getOrderStatus(
        nextStatus ? nextStatus : (status as OrderStatusKey),
        company,
      )}"`,
      icon: null,
      content: (
        <Text color='Text3' level={6}>
          โปรดยืนยันรายการ
        </Text>
      ),
      onOk: () =>
        onSubmitStatus({
          status: nextStatus ? nextStatus : status,
          paidStatus,
          cancelRemark: undefined,
          reason: !form.getFieldValue("reason") ? "-" : form.getFieldValue("reason"),
        }),
    });
  };

  const onSubmitOrder = async () => {
    const { remark } = navForm.getFieldsValue();
    const orderId = id;
    const assignedUserId = userProfile?.userNav;
    if (!assignedUserId) {
      Swal.fire({
        icon: "error",
        title: "ไม่สามารถส่งได้ เนื่องจากไม่มี user navision",
      });

      return;
    }

    const onOk = async () => {
      await submitToNav({
        orderId,
        remark,
        updateBy: `${firstname} ${lastname}`,
        assignedUserId,
        docType,
      })
        .then((res: any) => {
          const { success, userMessage } = res;
          if (success) {
            setNavSubmitStatus("success");
          } else {
            setNavSubmitStatus("failed");
          }
          setNavSubmitBody({ ...res, orderId, remark });
        })
        .catch((e: any) => {
          console.log(e);
        });
    };
    Modal.confirm({
      title: "ส่งคำสั่งซื้อไปที่ระบบ Navision",
      onOk,
    });
  };

  const PageTitle = () => {
    // ใช้ getOrderStatusInfo เพื่อดึงข้อมูลสถานะที่ถูกต้อง (รวมเงื่อนไข APPROVED_ORDER + isOverCredit === false)
    const statusInfo = orderData?.status
      ? getOrderStatusInfo(orderData.status, orderData?.isOverCredit)
      : null;

    const calPartialShipment =
      orderData?.orderProducts?.reduce((acc, curr: any) => {
        const qtyOutstanding = Number(curr.qtyOutstanding || "0");
        if (qtyOutstanding > 0) {
          return acc + qtyOutstanding;
        }
        return acc;
      }, 0) || 0;

    const calQtyShipment =
      orderData?.orderProducts?.reduce((acc, curr: any) => {
        const qtyShip = Number(curr.qtyShip || "0");
        if (qtyShip > 0) {
          return acc + qtyShip;
        }
        return acc;
      }, 0) || 0;

    return (
      <PageTitleNested
        title={`ORDER NO: ${orderData?.orderNo}`}
        showTag={
          <>
            {orderData?.isFlashSale && (
              <Tag color={"#FFF7C9"} style={{ borderRadius: "4px" }}>
                <Text color='BK' fontWeight={700}>
                  <img src={icon.thor_flash_sale} style={{ width: "12px", height: "15px" }} /> Flash
                  Sale
                </Text>
              </Tag>
            )}
          </>
        }
        showBack
        onBack={isSpecialRequestMode ? () => navigate(`/special-request`) : () => navigate(-1)}
        extra={
          <FlexCol align='end'>
            <Text
              level={3}
              fontWeight={700}
              style={{
                color: orderData?.status ? statusInfo?.text_color : undefined,
                fontWeight: 700,
              }}
            >
              {orderData?.status
                ? getOrderStatus(orderData?.status, company, orderData?.isOverCredit)
                : "-"}
            </Text>
            {calQtyShipment > 0 &&
              calPartialShipment > 0 &&
              !userCompany.companyType.includes("Fertilizer") && (
                <Tag style={{ borderRadius: 15, borderColor: "#7A6B0F", marginRight: "-2px" }}>
                  <Text style={{ color: "#7A6B0F" }} level={6}>
                    จัดส่งบางส่วน
                  </Text>
                </Tag>
              )}
            {/* <Text
              style={{
                color: orderData?.paidStatus
                  ? ORDER_PAYMENT_STATUS[orderData?.paidStatus].name_default
                  : undefined,
              }}
            >
              {orderData?.paidStatus
                ? ORDER_PAYMENT_STATUS[orderData?.paidStatus].name_default
                : "-"}
            </Text> */}
            <Text level={7}>
              วันที่อัปเดต&nbsp;
              {dayjs(orderData?.updateAt).locale("th").format(DATE_FORMAT)}
            </Text>
          </FlexCol>
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text: isSpecialRequestMode ? "รายการขอโปรโมชันพิเศษเพิ่มเติม" : "รายการคำสั่งซื้อ",
                path: isSpecialRequestMode ? "/special-request" : -1,
              },
              { text: "รายละเอียดคำสั่งซื้อ", path: window.location.pathname },
            ]}
          />
        }
      />
    );
  };

  const OrderDetail = () => {
    return (
      <Row gutter={16}>
        <Col span={12}>
          <CardContainer>
            <Text level={4} fontWeight={700}>
              รายละเอียดคำสั่งซื้อ
            </Text>
            <DetailBox style={{ height: 300 }}>
              <DetailItem label='ชื่อร้านค้า' value={orderData?.customerName} />
              <DetailItem label='Customer Code' value={orderData?.customerNo} />
              <DetailItem label='เขต' value={orderData?.customerZone} />
              <DetailItem label='SO NO.' value={orderData?.soNo} />
              <DetailItem label='Order No.' value={orderData?.orderNo} />
              <DetailItem
                label='ช่องทางการจ่ายเงิน'
                value={
                  <Text color={"primary"}>
                    {orderData?.paymentMethod
                      ? ORDER_PAYMENT_METHOD_NAME[orderData?.paymentMethod]
                      : "-"}
                  </Text>
                }
              />
              <DetailItem
                label='เอกสารที่เกี่ยวข้อง'
                value={
                  <Text
                    color={"primary"}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowFile(true)}
                  >
                    <img src={icons.viewFileIcon} />
                    &nbsp;ดูเอกสาร&nbsp;({orderData?.orderFiles?.length || 0}
                    &nbsp;รายการ)
                  </Text>
                }
              />
            </DetailBox>
          </CardContainer>
        </Col>
        <Col span={12}>
          <CardContainer>
            <Text level={4} fontWeight={700}>
              รายละเอียดการจัดส่ง
            </Text>
            <DetailBox style={{ height: 300 }}>
              {/* TODO */}
              <DetailItem
                label='การจัดส่ง'
                value={
                  orderData?.deliveryDest
                    ? ORDER_DELIVERY_DEST_METHOD_NAME[orderData?.deliveryDest]
                    : "-"
                }
              />
              <DetailItem label='ที่อยู่' value={orderData?.deliveryAddress} />
              {/* <DetailItem label='หมายเหตุการจัดส่ง' value={orderData?.deliveryRemark} /> */}
              {orderData?.deliveryFiles && orderData?.deliveryFiles?.length && (
                <DetailItem
                  label='เอกสารที่เกี่ยวข้อง'
                  value={
                    <Text
                      color={"primary"}
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowFileDelivery(true)}
                    >
                      <img src={icons.viewFileIcon} />
                      &nbsp;ดูเอกสาร&nbsp;(
                      {orderData?.deliveryFiles?.length}
                      &nbsp;รายการ)
                    </Text>
                  }
                />
              )}
              <DetailItem
                label='ข้อมูลทะเบียนรถ'
                value={`${mapTruckType[orderData?.truckType || "-"] || "-"} ${
                  orderData?.numberPlate || ""
                }`}
              />
            </DetailBox>
          </CardContainer>
        </Col>
      </Row>
    );
  };

  const OrderSummary = () => {
    const rowTextArea = 4;
    return (
      <Row gutter={16}>
        <Col span={isShowPrice ? 12 : 24}>
          <CardContainer>
            <Text level={4} fontWeight={700}>
              รวมหมายเหตุ***
            </Text>
            <br />
            <br />
            <Text level={5} fontWeight={700}>
              หมายเหตุ (สำหรับ Sale Co)
            </Text>
            <TextArea
              rows={rowTextArea}
              value={orderData?.saleCoRemark || "-"}
              disabled
              style={{
                borderColor: color.background2,
                color: color.BK,
                borderRadius: "16px",
                backgroundColor: color.background1,
              }}
            />
            <br />
            <br />
            <Text level={5} fontWeight={700}>
              หมายเหตุ (การจัดส่ง)
            </Text>
            <TextArea
              rows={rowTextArea}
              value={orderData?.deliveryRemark || "-"}
              disabled
              style={{
                borderColor: color.background2,
                color: color.BK,
                borderRadius: "16px",
                backgroundColor: color.background1,
              }}
            />
            <br />
            <br />
            <Text level={5} fontWeight={700}>
              หมายเหตุ (ขอส่วนลดพิเศษเพิ่ม)
            </Text>
            <TextArea
              rows={rowTextArea}
              value={orderData?.specialRequestRemark || "-"}
              disabled
              style={{
                borderColor: color.background2,
                color: color.BK,
                borderRadius: "16px",
                backgroundColor: color.background1,
              }}
            />
            <br />
            <br />
            <Text level={5} fontWeight={700}>
              หมายเหตุการยกเลิก (บริษัท)
            </Text>
            <TextArea
              rows={rowTextArea}
              value={orderData?.cancelRemark || "-"}
              disabled
              style={{
                borderColor: color.background2,
                color: color.BK,
                borderRadius: "16px",
                backgroundColor: color.background1,
              }}
            />
            <br />
            <br />
            <Text level={5} fontWeight={700}>
              หมายเหตุ (แก้ไขส่วนลด)
            </Text>
            <TextArea
              rows={rowTextArea}
              value={editCoRemarkPct || "-"}
              disabled
              style={{
                borderColor: color.background2,
                color: color.BK,
                borderRadius: "16px",
                backgroundColor: color.background1,
              }}
            />
          </CardContainer>
        </Col>
        {isShowPrice && (
          <Col span={12}>
            <CardContainer>
              <Row justify={"space-between"} gutter={16}>
                <Col style={{ paddingTop: 4 }}>
                  <Text level={4} fontWeight={700}>
                    สรุปรายการ
                  </Text>
                </Col>
                <Col>
                  <>
                    {coList?.filter((co) => co.type === "BILL_PCT").length > 0 &&
                      editCoList?.find((co) => co.type === "BILL_PCT") === undefined &&
                      (orderData?.status === "APPROVED_ORDER" ||
                        orderData?.status === "CONFIRM_ORDER" ||
                        orderData?.status === "APPROVE_SALE_ORDER") && (
                        <Button
                          title={
                            <>
                              <EditOutlined style={{ fontSize: 15, marginBottom: 4 }} />
                              &nbsp; เพิ่มส่วนลด % ของยอดบิล
                            </>
                          }
                          typeButton='primary-light'
                          onClick={() =>
                            setModalEditPctCo({
                              open: true,
                              value: coList?.find((co) => co.type === "BILL_PCT"),
                              action: "add",
                            })
                          }
                        />
                      )}
                    {editCoList?.find((co) => co.type === "BILL_PCT") !== undefined &&
                      (orderData?.status === "APPROVED_ORDER" ||
                        orderData?.status === "CONFIRM_ORDER" ||
                        orderData?.status === "APPROVE_SALE_ORDER") && (
                        <Button
                          title={
                            <>
                              <EditOutlined style={{ fontSize: 15, marginBottom: 4 }} />
                              &nbsp; แก้ไขส่วนลด % ของยอดบิล
                            </>
                          }
                          typeButton='primary-light'
                          onClick={() =>
                            setModalEditPctCo({
                              open: true,
                              value: editCoList.find((co) => co.type === "BILL_PCT"),
                              action: "edit",
                            })
                          }
                        />
                      )}
                  </>
                </Col>
              </Row>
              <DetailBox>
                <DetailItem
                  label='ราคาก่อนลด'
                  value={priceFormatter(orderData?.price || "0", undefined, true)}
                  alignRight
                  fontWeight={700}
                  fontSize={18}
                  leftSpan={10}
                />
                <DetailItem label='รายละเอียดส่วนลด' value=' ' fontWeight={700} fontSize={18} />
                <DetailDiscount orderData={orderData} />
                <br />
                <DetailItem
                  label='รวมส่วนลดสุทธิ'
                  value={priceFormatter(orderData?.totalDiscount || "0", undefined, true)}
                  fontWeight={700}
                  fontSize={18}
                  alignRight
                  leftSpan={10}
                />
                <DetailItem
                  label={`มูลค่ารวมหลังหักส่วนลด`}
                  value={priceFormatter(
                    (orderData?.price || 0) - (orderData?.totalDiscount || 0) || "0",
                    undefined,
                    true,
                  )}
                  fontWeight={700}
                  fontSize={18}
                  alignRight
                  leftSpan={10}
                />
                {!!orderData?.vat && orderData?.vat > 0 && (
                  <DetailItem
                    label={`ภาษีมูลค่าเพิ่ม ${orderData?.vatPercentage}%`}
                    value={priceFormatter(orderData?.vat || "0", undefined, true)}
                    fontWeight={700}
                    fontSize={18}
                    alignRight
                    leftSpan={10}
                  />
                )}
                <Divider />
                <DetailItem
                  label='ราคารวม'
                  value={
                    <Text color='primary' fontWeight={700} fontSize={32}>
                      {priceFormatter(orderData?.totalPrice || "0", undefined, true)}
                    </Text>
                  }
                  fontWeight={700}
                  fontSize={24}
                  alignRight
                  leftSpan={10}
                />
              </DetailBox>
            </CardContainer>
          </Col>
        )}
      </Row>
    );
  };

  const orderStatusSelectOptions = [
    "WAIT_CONFIRM_ORDER",
    "CONFIRM_ORDER",
    "OPEN_ORDER",
    "IN_DELIVERY",
    "DELIVERY_SUCCESS",
  ];

  const mapStatusShowTabPending = ["OPEN_ORDER", "IN_DELIVERY", "DELIVERY_SUCCESS"];

  const orderStatusOption = (
    <CardContainer>
      <Form form={form} onFinish={() => updateStatus()}>
        <Row gutter={16} justify='end'>
          <Col span={4}>
            {orderData?.status !== "WAIT_CONFIRM_ORDER" && (
              <Button
                title='ยกเลิกคำสั่งซื้อ'
                typeButton='danger'
                onClick={() => setCancelModal(true)}
              />
            )}
          </Col>
          <Col span={isDevelopment ? 12 : 20} />
          {isDevelopment && (
            <>
              <Col span={4}>
                <Form.Item
                  name='status'
                  noStyle
                  initialValue={
                    orderStatusSelectOptions.includes(`${orderData?.status}`)
                      ? orderData?.status
                      : undefined
                  }
                >
                  <Select
                    data={orderStatusSelectOptions.map((key) => ({
                      key,
                      value: key,
                      label: getOrderStatus(key as OrderStatusKey, company),
                    }))}
                    style={{ width: "100%" }}
                    placeholder='สถานะ'
                  />
                </Form.Item>
              </Col>
              <Col span={0}>
                <Form.Item name='paidStatus' noStyle initialValue={orderData?.paidStatus}>
                  <Select
                    data={Object.entries(ORDER_PAYMENT_STATUS).map(([key, { name_default }]) => ({
                      key,
                      value: key,
                      label: name_default,
                    }))}
                    style={{ width: "100%" }}
                    placeholder='สถานะการชำระเงิน'
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Button title='ปรับสถานะคำสั่งซื้อ' htmlType='submit' loading={updating} />
              </Col>
            </>
          )}
        </Row>
      </Form>
    </CardContainer>
  );

  const OrderNavOption = () => {
    const step = navSubmitStatus; //"success" 'wait' 'failed';
    const info = {
      wait: {
        borderColor: undefined,
        icon: undefined,
        editable: true,
        title: (
          <Row align='middle' justify='space-between'>
            <Col span={20}>
              <div>
                <Text level={2}>
                  ส่งคำสั่งซื้อไปที่ระบบ <span style={{ color: color.primary }}>Navision</span>
                </Text>
                &nbsp;
                <Text level={5}>
                  เมื่อตรวจสอบคำสั่งซื้อเรียบร้อยให้กดปุ่ม “ส่งการสั่งซื้อทันที”
                </Text>
              </div>
            </Col>
            <Col span={4}>
              <Row justify='end'>
                <Button
                  title='ส่งการสั่งซื้อทันที'
                  style={{ width: "180px" }}
                  onClick={onSubmitOrder}
                />
              </Row>
            </Col>
          </Row>
        ),
      },
      success: {
        borderColor: color.success,
        icon: icons.resultSuccess,
        editable: false,
        title: (
          <>
            <Text level={2} color='success'>
              ส่งคำสั่งซื้อไปยังระบบ Navision แล้ว
            </Text>
            <br />
            <Text>
              SO Number {navSubmitBody?.responseData?.Order_No} อัปเดตไปยังระบบล่าสุด เมื่อ&nbsp;
              {moment(navSubmitBody?.responseDateTime).format("DD/MM/YYYY HH:mm")}
            </Text>
            <br />
          </>
        ),
      },
      failed: {
        borderColor: color.warning,
        icon: icons.resultFailed,
        editable: false,
        title: (
          <>
            <Text level={2} color='warning'>
              ส่งคำสั่งซื้อไปยังระบบ Navision ไม่สำเร็จ “โปรดติดต่อทีม Support”
            </Text>
            <br />
            <Text>
              อัปเดตไปยังระบบล่าสุด เมื่อ&nbsp;
              {moment(navSubmitBody?.responseDateTime).format("DD/MM/YYYY HH:mm")}
            </Text>
            <br />
            <Text level={6} color='error'>
              message:&nbsp;{navSubmitBody?.userMessage}
            </Text>
            <br />
            <Text level={6} color='error'>
              ({navSubmitBody?.developerMessage})
            </Text>
            <br />
          </>
        ),
      },
    };
    const { borderColor, icon, title, editable } = info[step];
    return (
      <NavResponseBox color={borderColor}>
        <FlexRow style={{ width: "100%" }}>
          {icon && (
            <div>
              <img src={icon} />
            </div>
          )}
          <div style={{ width: "100%", paddingLeft: editable ? 0 : 20 }}>
            {title}
            <br />
            <Form form={navForm} layout='vertical'>
              <Form.Item name='remark' label='เงื่อนไข Memo'>
                <TextArea disabled={!editable} />
              </Form.Item>
            </Form>
          </div>
        </FlexRow>
      </NavResponseBox>
    );
  };

  const getOption = () => {
    switch (orderData?.status) {
      case "WAIT_APPROVE_ORDER":
        return !isSpecialRequestMode ? (
          <></>
        ) : (
          <>
            <br />
            <CardContainer>
              <Row gutter={16} align='middle' justify='end'>
                <Col span={3}>
                  <Row justify='end'>
                    <Text>จัดการคำสั่งซื้อ :</Text>
                  </Row>
                </Col>
                <Col span={3}>
                  <Button
                    title='ปฎิเสธ'
                    typeButton='danger'
                    onClick={() => setCancelModal(true)}
                    // onClick={() => updateStatus("REJECT_ORDER")}
                  />
                </Col>
                <Col span={3}>
                  <Button
                    title='อนุมัติ'
                    typeButton='primary'
                    onClick={() => setApproveSqModal(true)}
                  />
                </Col>
              </Row>
            </CardContainer>
          </>
        );
      case "WAIT_CONFIRM_ORDER":
      case "OPEN_ORDER":
      case "IN_DELIVERY":
      case "WAIT_APPROVE_OVER_CREDIT":
      case "WAIT_APPROVE_SALE_ORDER":
        return isSpecialRequestMode ? (
          <></>
        ) : (
          <>
            <br />
            {orderStatusOption}
          </>
        );
      //
      case "CONFIRM_ORDER":
      case "APPROVE_SALE_ORDER":
      case "APPROVED_ORDER":
        return isSpecialRequestMode ? (
          <></>
        ) : (
          <>
            <br />
            {checkCompany(userCompany.companyCode) ? <OrderNavOption /> : <></>}
            <br />
            {orderStatusOption}
          </>
        );
      case "DELIVERY_SUCCESS":
        return <></>;
      default:
        return <></>;
    }
  };

  const dataTabs = [
    {
      key: "product",
      label: `รายการสินค้าทั้งหมด`,
      hidden: false,
      children: (
        <TabProduct
          statusOrder={orderData?.status || ""}
          isShowPrice={isShowPrice}
          data={orderData?.orderProducts || []}
          orderId={id || ""}
          editCoList={editCoList}
          company={company}
          visibleColumns={visibleColumns}
          setVisibleColumns={setVisibleColumns}
        />
      ),
    },
    {
      key: "pending",
      label: `ติดตามการจัดส่ง`,
      hidden:
        userCompany.companyType === "Chemical" &&
        mapStatusShowTabPending.includes(orderData?.status || "")
          ? false
          : true,
      children: <TabPending orderData={orderData} company={company} />,
    },
    {
      key: "shipment",
      label: `ลำดับการขนสินค้า`,
      hidden: userCompany.companyType === "Chemical" ? true : false,
      children: <TabShipment orderData={orderData} />,
    },
    {
      key: "invoices",
      label: `ใบแจ้งหนี้และเอกสารอื่นๆ (${invoices?.length || 0})`,
      hidden: false,
      children: <TabInvoice invoices={invoices} company={company} />,
    },
  ].filter((t) => !t.hidden);

  const approverMode = Boolean(
    orderData?.hasSpecialRequest ||
      orderData?.orderCreditApprovers?.length ||
      orderData?.orderSoApprovers?.length,
  );

  return loading ? (
    <CardContainer>
      <PageSpin />
    </CardContainer>
  ) : (
    <>
      <CardContainer>
        <PageTitle />
      </CardContainer>
      <br />
      <OrderDetail />
      <br />
      <CardContainer>
        <Row justify={"space-between"} gutter={16}>
          <Col>
            <Text level={4} fontWeight={700}>
              รายการสินค้า
            </Text>
          </Col>
          <Col>
            {(coList.filter((c) => c.type === "SKU")?.length > 0 ||
              editCoList.filter((c) => c.type === "SKU")?.length > 0) &&
              (orderData?.status === "APPROVED_ORDER" ||
                orderData?.status === "CONFIRM_ORDER" ||
                orderData?.status === "APPROVE_SALE_ORDER") && (
                <Dropdown
                  menu={{
                    items: [
                      // {
                      //   label: <span style={{ fontSize: 16 }}>รายการส่วนลดทั้งหมด</span>,
                      //   key: "1",
                      //   onClick: () => setModalCo({ key: 1, open: true, value: "รายการส่วนลดทั้งหมด" }),
                      // },
                      {
                        label: <span style={{ fontSize: 16 }}>เพิ่มรายการส่วนลด</span>,
                        key: "1",
                        disabled: coList?.filter((co) => co.type === "SKU")?.length === 0,
                        onClick: () =>
                          setModalCo({ key: 1, open: true, value: "เพิ่มรายการส่วนลด" }),
                      },
                      {
                        label: <span style={{ fontSize: 16 }}>แก้ไขรายการส่วนลด</span>,
                        key: "2",
                        disabled: editCoList?.length === 0,
                        onClick: () =>
                          setModalCo({
                            key: 2,
                            open: true,
                            value: "เลือกรายการส่วนลดที่ต้องการแก้ไข",
                          }),
                      },
                    ],
                  }}
                >
                  <Button
                    title={
                      <>
                        จัดการส่วนลดรายสินค้า&nbsp;&nbsp;
                        <DownOutlined style={{ fontSize: 10, marginBottom: 4 }} />
                      </>
                    }
                    typeButton='primary-light'
                  />
                </Dropdown>
              )}
          </Col>
        </Row>
        <Tabs
          items={dataTabs}
          onChange={(key) => setTab(key)}
          activeKey={tab}
          style={{ fontFamily: "IBM Plex Sans Thai" }}
        />
        <br />
        <FooterTab orderData={orderData} />
      </CardContainer>
      <br />
      <OrderSummary />
      {approverMode && (
        <CardContainer style={{ marginTop: 16, paddingBottom: "6%" }}>
          {orderData?.hasSpecialRequest && (
            <EvidenceSection
              data={[]}
              orderData={orderData}
              title='หลักฐานการอนุมัติคำสั่งซื้อพิเศษ'
              type='specialRequest'
            />
          )}
          {orderData?.orderCreditApprovers && orderData?.orderCreditApprovers?.length > 0 && (
            <EvidenceSection
              data={orderCreditApprovers || []}
              title='หลักฐานการอนุมัติวงเงินเกิน'
              type='credit'
              orderData={orderData}
              otherApprovers={orderSoApprovers || []}
            />
          )}
          {orderData?.orderSoApprovers && orderData?.orderSoApprovers?.length > 0 && (
            <EvidenceSection
              data={orderSoApprovers || []}
              title='หลักฐานการอนุมัติใบสั่งขาย'
              type='so'
              orderData={orderData}
              otherApprovers={orderCreditApprovers || []}
            />
          )}
        </CardContainer>
      )}
      <br />
      {orderData?.status == "WAIT_APPROVE_SALE_ORDER" && isApproveSo && (
        <SoApprove
          showApproveSoModal={showApproveSoModal}
          setShowApproveSoModal={setShowApproveSoModal}
          form={form}
          orderId={id}
        />
      )}
      {!isViewMode && (
        <Permission
          permission={isSpecialRequestMode ? ["specialRequest", "approve"] : ["orderList", "edit"]}
        >
          <div>{getOption()}</div>
        </Permission>
      )}
      {showCancelModal && (
        <Modal open={showCancelModal} footer={false} closable={false} width={420}>
          <FlexCol>
            <Text level={4} fontWeight={700}>
              {isSpecialRequestMode
                ? `เหตุผลที่ปฎิเสธคำขอสั่งซื้อพิเศษ`
                : `เหตุผลยกเลิกคำสั่งซื้อ (โดยบริษัท)`}
            </Text>
            <br />
          </FlexCol>
          <Form form={form}>
            <Form.Item noStyle name='cancelRemark'>
              <TextArea rows={6} placeholder='โปรดระบุเหตุผล...' />
            </Form.Item>
          </Form>
          <br />
          <Row gutter={16} justify={"end"}>
            <Col span={6}>
              <Button
                title='ยกเลิก'
                typeButton='primary-light'
                style={{ width: "100%", height: "32px", lineHeight: "32px", padding: "0 16px" }}
                onClick={() => {
                  setCancelModal(false);
                  form.resetFields(["cancelRemark"]);
                }}
              />
            </Col>
            <Col span={6}>
              <Button
                title='ยืนยัน'
                typeButton={cancelRemark ? "primary" : "disabled"}
                style={{ width: "100%", height: "32px", lineHeight: "32px", padding: "0 16px" }}
                loading={updating}
                disabled={updating || !cancelRemark}
                onClick={() =>
                  cancelRemark &&
                  !updating &&
                  onSubmitStatus({
                    status: isSpecialRequestMode ? "REJECT_ORDER" : "COMPANY_CANCEL_ORDER",
                    cancelRemark: cancelRemark,
                  })
                }
              />
            </Col>
          </Row>
        </Modal>
      )}
      {showApproveSqModal && (
        <Modal open={showApproveSqModal} footer={false} closable={false} width={420}>
          <FlexCol>
            <Text level={4} fontWeight={700}>
              {`เหตุผลที่อนุมัติคำขอสั่งซื้อพิเศษ`}
            </Text>
            <br />
          </FlexCol>
          <Form form={form}>
            <Form.Item noStyle name='reason'>
              <TextArea rows={6} placeholder='โปรดระบุเหตุผล...' />
            </Form.Item>
          </Form>
          <br />
          <Row gutter={16} justify={"end"}>
            <Col span={6}>
              <Button
                title='ยกเลิก'
                typeButton='primary-light'
                style={{ width: "100%", height: "32px", lineHeight: "32px", padding: "0 16px" }}
                onClick={() => {
                  setApproveSqModal(false);
                  form.resetFields(["reason"]);
                }}
              />
            </Col>
            <Col span={6}>
              <Button
                title='ยืนยัน'
                typeButton='primary'
                style={{ width: "100%", height: "32px", lineHeight: "32px", padding: "0 16px" }}
                loading={updating}
                onClick={() =>
                  onSubmitStatus({
                    status: "WAIT_CONFIRM_ORDER",
                    cancelRemark: undefined,
                    reason: !form.getFieldValue("reason") ? "-" : form.getFieldValue("reason"),
                  })
                }
              />
            </Col>
          </Row>
        </Modal>
      )}
      {showFile && (
        <Modal
          open={showFile}
          footer={false}
          width={420}
          onCancel={() => setShowFile(false)}
          centered
        >
          <Text level={5} fontWeight={700}>
            เอกสารที่เกี่ยวข้อง
          </Text>
          <br />
          <Text level={5} color='Text3'>
            ทั้งหมด {orderData?.orderFiles?.length} รายการ
          </Text>
          <br />
          <br />
          {orderData?.orderFiles?.map((file) => <FileItem key={file.orderFileId} file={file} />)}
        </Modal>
      )}
      {showFileDelivery && (
        <Modal
          open={showFileDelivery}
          footer={false}
          width={420}
          onCancel={() => setShowFileDelivery(false)}
          centered
        >
          <Text level={5} fontWeight={700}>
            เอกสารที่เกี่ยวข้องกับการจัดส่ง
          </Text>
          <br />
          <Text level={5} color='Text3'>
            ทั้งหมด {orderData?.deliveryFiles?.length} รายการ
          </Text>
          <br />
          <br />
          {orderData?.deliveryFiles?.map((file, i) => (
            <FileItem
              key={file}
              file={{
                filePath: file,
                isDeleted: false,
                orderFileId: `${i}`,
                orderId: orderData?.orderId,
              }}
            />
          ))}
        </Modal>
      )}
      {(modalCo.key === 1 || modalCo.key === 2) && (
        <AddCoListModal
          open={modalCo}
          onCancel={() => setModalCo({ ...modalCo, open: false })}
          orderId={id}
          editCoList={editCoList}
          fetchData={() => {
            fetchData();
            fetchCoAvalibleList();
          }}
        />
      )}
      {modalEditPctCo.open && (
        <ModalEditPctCo
          open={modalEditPctCo.open}
          data={modalEditPctCo.value}
          onCancel={() => {
            setModalEditPctCo({ open: false, value: {}, action: "" });
          }}
          orderData={orderData}
          fetchData={() => {
            fetchData();
            fetchCoAvalibleList();
          }}
          action={modalEditPctCo.action}
        />
      )}
    </>
  );
};

export const DetailDiscount = ({
  orderData,
  scroll,
  isSkeleton = false,
}: {
  orderData: any;
  scroll?: boolean;
  isSkeleton?: boolean;
}) => {
  return (
    <DetailBox
      style={{
        backgroundColor: "white",
        padding: 10,
        ...(scroll && { maxHeight: 150, overflowY: "auto", overflowX: "hidden" }),
      }}
    >
      <DetailItem
        label='ส่วนลดรายการ'
        labelEn='Discount Promotion'
        value={priceFormatter(
          orderData?.promotionDiscount + orderData?.flashSaleDiscount || "0",
          undefined,
          true,
        )}
        color='error'
        alignRight
        style={{ color: "#2ED477" }}
        isSkeleton={isSkeleton}
      />
      {orderData?.company === "ICPL" && (
        <DetailItem
          label='ส่วนลดพิเศษ'
          labelEn='Special Discount'
          value={priceFormatter(orderData?.specialRequestDiscount || "0", undefined, true)}
          style={{ color: "#0068F4" }}
          alignRight
          isSkeleton={isSkeleton}
        />
      )}
      <DetailItem
        label='ส่วนลดโควตา'
        labelEn='Discount Quota'
        value={priceFormatter(orderData?.quotaDiscount || "0", undefined, true)}
        style={{ color: "#9B51E0" }}
        alignRight
        isSkeleton={isSkeleton}
      />
      <DetailItem
        label=' ส่วนลดดูแลราคา'
        labelEn='CO. ดูแลราคา / วงเงินเคลม'
        value={priceFormatter(orderData?.coDiscount || "0", undefined, true)}
        color='success'
        alignRight
        style={{ color: "#F46363" }}
        isSkeleton={isSkeleton}
      />
      {(orderData?.pct > 0 || orderData?.coDiscountDetail?.billPct > 0) && !isSkeleton && (
        <Card style={{ backgroundColor: "#F6F7F9" }} bodyStyle={{ padding: "8px" }}>
          <Row justify={"space-between"} gutter={16}>
            <Col>
              <Text level={6}>ส่วนลดรายสินค้า</Text>
            </Col>
            <Col>
              <Text
                color={
                  orderData?.skuCoDiscount > 0 || orderData?.coDiscountDetail?.skuCoDiscount > 0
                    ? "error"
                    : "Text1"
                }
                level={6}
              >
                {priceFormatter(
                  orderData?.skuCoDiscount || orderData?.coDiscountDetail?.skuCoDiscount || "0",
                  undefined,
                  true,
                )}
              </Text>
            </Col>
          </Row>
          <Row justify={"space-between"} gutter={16}>
            <Col>
              <Text level={6}>
                ส่วนลด % ของยอดบิล ({orderData?.pct || orderData?.coDiscountDetail?.billPct || 0}%)
              </Text>
            </Col>
            <Col>
              <Text
                color={
                  orderData?.billCoDiscount > 0 || orderData?.coDiscountDetail?.billCoDiscount > 0
                    ? "error"
                    : "Text1"
                }
                level={6}
              >
                {priceFormatter(
                  orderData?.billCoDiscount || orderData?.coDiscountDetail?.billCoDiscount || "0",
                  undefined,
                  true,
                )}
              </Text>
            </Col>
          </Row>
        </Card>
      )}
      {orderData?.company === "ICPL" && (
        <>
          <DetailItem
            label='ส่วนลดเงินสด'
            labelEn='Cash'
            value={priceFormatter(orderData?.cashDiscount || "0", undefined, true)}
            color='secondary'
            style={{ color: "#FF9138" }}
            alignRight
            isSkeleton={isSkeleton}
          />
        </>
      )}
    </DetailBox>
  );
};

export const TabProduct = ({
  orderId,
  isShowPrice,
  data,
  editCoList,
  company,
  statusOrder,
  visibleColumns,
  setVisibleColumns,
}: {
  orderId: string;
  isShowPrice: boolean;
  data: any;
  editCoList: any;
  company: string;
  statusOrder: string;
  visibleColumns: string[];
  setVisibleColumns: (columns: string[]) => void;
}) => {
  const [orderTab, setOrderTab] = useState("main");
  const [dynamicCoColumns, setDynamicCoColumns] = useState<any[]>([]);
  const [dynamicPromotionColumns, setDynamicPromotionColumns] = useState<any[]>([]);
  const [dynamicQuotaColumns, setDynamicQuotaColumns] = useState<any[]>([]);
  const [dynamicSpecialColumns, setDynamicSpecialColumns] = useState<any[]>([]);
  const [orderDiscount, setOrderDiscount] = useState<any[]>([]);

  const fetchOrderDiscount = async () => {
    await getOrderDiscount(orderId).then(async (res: any) => {
      const orderProducts: any = res.orderProducts;
      const splitLine: any = res.splitLines;
      const mapDiscount: any[] = [];
      const dycamicColumnCo: any[] = [];
      const dycamicColumnPromotion: any = [];
      const dycamicColumnQuota: any[] = [];
      const dycamicColumnSpecial: any[] = [];

      await orderProducts.map((item: any) => {
        const findDiscount = splitLine.filter(
          (s: any) => `${s.orderProductId}` === `${item.orderProductId}`,
        );
        if (findDiscount.length > 0) {
          findDiscount.map((fd: any) => {
            const findQuota = fd.discounts.filter((d: any) => d?.sourceType === "PRODUCT_QUOTA");
            const findCo = fd.discounts.filter((d: any) => d?.sourceType === "CO_SKU");
            const findPromotion = fd.discounts.filter((d: any) => d?.sourceType === "PROMOTION");
            const findSpecial = fd.discounts.filter(
              (d: any) => d?.sourceType === "SPECIAL_REQUEST",
            );

            dycamicColumnPromotion.push(...findPromotion);
            dycamicColumnCo.push(...findCo);
            dycamicColumnQuota.push(...findQuota);
            dycamicColumnSpecial.push(...findSpecial);

            mapDiscount.push({
              productId: item.productId,
              productName: item.productName,
              commonName: item.commonName,
              productImage: item.productImage,
              packSize: item.packSize,
              saleUOMTH: item.saleUOMTH,
              productCodeNAV: item.productCodeNAV,
              quantity: fd.quantity,
              findQuota: findQuota,
              findCo: findCo,
              findPromotion: findPromotion,
              findSpecial: findSpecial,
              totalDiscount: fd.lineDiscount,
            });
          });
        }
      });
      let groupColumnCo: any = _.groupBy(dycamicColumnCo, (item: any) => item.coName);
      groupColumnCo = Object.entries(groupColumnCo).map(([coName, items]: [string, any]) => {
        return {
          title: coName,
          dataIndex: coName,
          key: coName,
        };
      });
      let groupColumnPromotion: any = _.groupBy(dycamicColumnPromotion, (item: any) => item.label);
      groupColumnPromotion = Object.entries(groupColumnPromotion).map(
        ([label, items]: [string, any]) => {
          return {
            title: label,
            dataIndex: label,
            key: label,
          };
        },
      );
      let groupColumnQuota: any = _.groupBy(dycamicColumnQuota, (item: any) => item.quotaName);
      groupColumnQuota = Object.entries(groupColumnQuota).map(
        ([quotaName, items]: [string, any]) => {
          return {
            title: quotaName,
            dataIndex: quotaName,
            key: quotaName,
          };
        },
      );
      let groupColumnSpecial: any = _.groupBy(dycamicColumnSpecial, (item: any) => item.label);
      groupColumnSpecial = Object.entries(groupColumnSpecial).map(
        ([label, items]: [string, any]) => {
          return {
            title: label,
            dataIndex: label,
            key: label,
          };
        },
      );

      const grandTotal = {
        productName: "Total",
        quantity: _.sumBy(mapDiscount, (item: any) => item.quantity),
        totalDiscount: _.sumBy(mapDiscount, (item: any) => item.totalDiscount),
        findPromotion:
          groupColumnPromotion.length > 0
            ? [
                ...groupColumnPromotion.map((item: any) => {
                  return {
                    sourceType: "PROMOTION",
                    promotionCode: item.key,
                    label: item.key,
                    amount: _.sumBy(
                      mapDiscount.flatMap((d: any) =>
                        d?.findPromotion
                          ?.filter((p: any) => p.label === item.key)
                          .map((f: any) => f.amount),
                      ) || 0,
                    ),
                  };
                }),
              ]
            : [],
        findCo:
          groupColumnCo.length > 0
            ? [
                ...groupColumnCo.map((item: any) => {
                  return {
                    sourceType: "CO_SKU",
                    coCode: item.key,
                    coName: item.key,
                    amount: _.sumBy(
                      mapDiscount.flatMap((d: any) =>
                        d?.findCo
                          ?.filter((p: any) => p.coName === item.key)
                          .map((f: any) => f.amount),
                      ) || 0,
                    ),
                  };
                }),
              ]
            : [],
        findQuota:
          groupColumnQuota.length > 0
            ? [
                ...groupColumnQuota.map((item: any) => {
                  return {
                    sourceType: "QUOTA",
                    quotaCode: item.key,
                    quotaName: item.key,
                    amount: _.sumBy(
                      mapDiscount.flatMap((d: any) =>
                        d?.findQuota
                          ?.filter((p: any) => p.quotaName === item.key)
                          .map((f: any) => f.amount),
                      ) || 0,
                    ),
                  };
                }),
              ]
            : [],
        findSpecial:
          groupColumnSpecial.length > 0
            ? [
                ...groupColumnSpecial.map((item: any) => {
                  return {
                    sourceType: "SPECIAL_REQUEST",
                    label: item.key,
                    amount: _.sumBy(
                      mapDiscount.flatMap((d: any) =>
                        d?.findSpecial
                          ?.filter((p: any) => p.label === item.key)
                          .map((f: any) => f.amount),
                      ) || 0,
                    ),
                  };
                }),
              ]
            : [],
      };

      setOrderDiscount(mapDiscount.concat(grandTotal));
      setDynamicCoColumns(groupColumnCo);
      setDynamicPromotionColumns(groupColumnPromotion);
      setDynamicQuotaColumns(groupColumnQuota);
      setDynamicSpecialColumns(groupColumnSpecial);
    });
  };

  useEffectOnce(() => {
    fetchOrderDiscount();
  });

  const navigate = useNavigate();
  const priceColumnKeys = [
    "marketPrice",
    "price",
    "specialRequestDiscount",
    "specialRequestDiscountPerUnit",
    "discount",
    "discountPerUnit",
    "quotaDiscount",
    "discountPerUnit",
  ];

  const columns: any = [
    ...rawColumns
      .map((c) => ({
        ...c,
        title: c.title2 ? (
          <DoubleRowTitle top={c.title} bottom={c.title2} bottomSize={c.bottomSize} />
        ) : (
          <Text level={5} fontWeight={700}>
            {c.title}
          </Text>
        ),
      }))
      .filter((c) => visibleColumns.includes(c.key))
      .filter((c) => isShowPrice || !priceColumnKeys?.includes(c.key)),
  ];

  const updateVisibleColumn = (isPush: boolean, key: string) => {
    let newColumns;
    if (isPush) {
      newColumns = [...visibleColumns, key];
    } else {
      newColumns = visibleColumns.filter((c) => c !== key);
    }
    setVisibleColumns(newColumns);
    localStorage.setItem(storageColumnKey, JSON.stringify(newColumns));
  };

  const coColumns = [
    {
      title: "จำนวนสินค้า",
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      render: (value: any, row: any, index: number) => {
        const mapData = data.find((d) => d.productId === row?.productId);
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value)}</Text>
              <Text color='Text3' level={6}>
                {numberFormatter(mapData?.marketPrice)} บาท / {mapData?.saleUOMTH}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ส่วนลด/หน่วย",
      dataIndex: "discountValue",
      key: "discountValue",
      width: 82,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value)}</Text>
              <Text color='Text3' level={6}>
                {row?.discountMode?.includes("PCT")
                  ? `% / ${row?.saleUOMTH}`
                  : `บาท / ${row?.saleUOMTH}`}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รวมส่วนลดรายการนี้",
      dataIndex: "coDiscount",
      key: "coDiscount",
      width: 100,
      render: (value: any, row: any, index: number) => {
        const mapData = data.find((d) => d.productId === row?.productId);
        return {
          children: (
            <FlexCol>
              <Text color={value > 0 ? "error" : "Text1"}>
                {value > 0 ? `-${numberFormatter(value)}` : numberFormatter(value)}
              </Text>
              <Text color='Text3' level={6}>
                {row?.discountMode.includes("PCT")
                  ? `(${numberFormatter(mapData?.marketPrice)} x ${numberFormatter(row?.quantity)}) x ${numberFormatter(row?.discountValue)}%`
                  : `${numberFormatter(row?.quantity)} x ${numberFormatter(row?.discountValue)}`}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  const orderDiscountColumes = [
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Text fontWeight={600}>ชื่อสินค้า</Text>
        </div>
      ),
      dataIndex: "productName",
      key: "productName",
      width: "20%",
      fixed: "left" as FixedType,
      render: (productName: string, product: any, index: number) => {
        return {
          children: (
            <>
              {product?.productName === "Total" ? (
                <Text fontWeight={600} level={5}>
                  Total
                </Text>
              ) : (
                <FlexRow align='center'>
                  <div style={{ marginRight: 16 }}>
                    <Image
                      src={product?.productImage || image.product_no_image}
                      style={{
                        width: "55px",
                        height: "55px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <FlexCol>
                    <Text level={5}>{productName}</Text>
                    <Text level={6} color='Text3'>
                      {product?.productCodeNAV || product?.productFreebiesCodeNAV}
                    </Text>
                    {company === "ICPL" && (
                      <>
                        <Text level={6} color='Text3'>
                          {product?.commonName}
                        </Text>
                        <Text level={6} color='Text3'>
                          pack size: {product?.packSize}
                        </Text>
                      </>
                    )}
                  </FlexCol>
                </FlexRow>
              )}
            </>
          ),
        };
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Text fontWeight={600}>จำนวน</Text>
        </div>
      ),
      dataIndex: "quantity",
      key: "quantity",
      width: "6%",
      fixed: "left" as FixedType,
      render: (value: string, product: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              {product?.productName === "Total" ? (
                <Text fontWeight={600} level={5}>
                  {Number(value).toFixed(2)}
                </Text>
              ) : (
                <FlexCol>
                  <Text level={5}>{Number(value).toFixed(2)}</Text>
                  <Text level={6} color='Text3'>
                    {product?.saleUOMTH}
                  </Text>
                </FlexCol>
              )}
            </FlexCol>
          ),
        };
      },
    },
    ...(dynamicPromotionColumns.length > 0
      ? [
          {
            title: (
              <div style={{ textAlign: "center" }}>
                <Text fontWeight={600} color='white'>
                  รายการ Promotion (บาท)
                </Text>
              </div>
            ),
            onHeaderCell: () => ({
              style: {
                backgroundColor: "#2ED477",
              },
            }),
            children: dynamicPromotionColumns.map((col: any) => {
              return {
                title: (
                  <div style={{ textAlign: "center" }}>
                    <Text fontWeight={600} color='white'>
                      {col.title}
                    </Text>
                  </div>
                ),
                dataIndex: col.title,
                key: col.title,
                //width: "12%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#2ED477",
                  },
                }),
                render: (value: string, product: any, index: number) => {
                  const findPromotion =
                    product.findPromotion.find((c: any) => c.label === col.title) || null;
                  return {
                    children: (
                      <>
                        {findPromotion ? (
                          <FlexCol style={{ alignItems: "flex-end" }}>
                            <Text level={5} fontWeight={600} color='error'>
                              -
                              {priceFormatter(findPromotion?.amount || "0", undefined, false, true)}
                            </Text>
                            {product?.productName !== "Total" && (
                              <Text level={6} color='Text3'>
                                (
                                {priceFormatter(
                                  findPromotion?.unitAmount || "0",
                                  undefined,
                                  false,
                                  true,
                                )}{" "}
                                บาท *{" "}
                                {priceFormatter(
                                  findPromotion?.coveredQty || "0",
                                  undefined,
                                  false,
                                  true,
                                )}{" "}
                                {product?.saleUOMTH})
                              </Text>
                            )}
                          </FlexCol>
                        ) : (
                          <FlexCol style={{ alignItems: "flex-end" }}>
                            <Text>-</Text>
                          </FlexCol>
                        )}
                      </>
                    ),
                  };
                },
              };
            }),
          },
        ]
      : []),
    ...(dynamicSpecialColumns.length > 0
      ? [
          {
            title: (
              <div style={{ textAlign: "center" }}>
                <Text fontWeight={600} color='white'>
                  Special Request
                </Text>
              </div>
            ),
            dataIndex: "special",
            key: "special",
            onHeaderCell: () => ({
              style: {
                backgroundColor: "#0068F4",
              },
            }),
            render: (value: string, product: any) => {
              const findSpecial =
                product.findSpecial?.find((c: any) => c.sourceType === "SPECIAL_REQUEST") || null;
              return {
                children: findSpecial ? (
                  <FlexCol style={{ alignItems: "flex-end" }}>
                    <Text level={5} fontWeight={600} color='error'>
                      -{priceFormatter(findSpecial.amount || "0", undefined, false, true)}
                    </Text>

                    {product?.productName !== "Total" && (
                      <Text level={6} color='Text3'>
                        ({priceFormatter(findSpecial.unitAmount || "0", undefined, false, true)} บาท
                        * {priceFormatter(findSpecial.coveredQty || "0", undefined, false, true)}{" "}
                        {product?.saleUOMTH})
                      </Text>
                    )}
                  </FlexCol>
                ) : (
                  <FlexCol style={{ alignItems: "flex-end" }}>
                    <Text>-</Text>
                  </FlexCol>
                ),
              };
            },
          },
        ]
      : []),
    ...(dynamicQuotaColumns.length > 0
      ? [
          {
            title: (
              <div style={{ textAlign: "center" }}>
                <Text fontWeight={600} color='white'>
                  รายการ Quota (บาท)
                </Text>
              </div>
            ),
            onHeaderCell: () => ({
              style: {
                backgroundColor: "#9B51E0",
              },
            }),
            children: dynamicQuotaColumns.map((col: any) => {
              return {
                title: (
                  <div style={{ textAlign: "center" }}>
                    <Text fontWeight={600} color='white'>
                      {col.title}
                    </Text>
                  </div>
                ),
                dataIndex: col.title,
                key: col.title,
                //width: "12%",
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: "#9B51E0",
                  },
                }),
                render: (value: string, product: any, index: number) => {
                  const findQuota =
                    product.findQuota.find((c: any) => c.quotaName === col.title) || null;
                  return {
                    children: (
                      <>
                        {findQuota ? (
                          <FlexCol style={{ alignItems: "flex-end" }}>
                            <Text level={5} fontWeight={600} color='error'>
                              -{priceFormatter(findQuota?.amount || "0", undefined, false, true)}
                            </Text>
                            {product?.productName !== "Total" && (
                              <Text level={6} color='Text3'>
                                (
                                {priceFormatter(
                                  findQuota?.unitAmount || "0",
                                  undefined,
                                  false,
                                  true,
                                )}{" "}
                                บาท *{" "}
                                {priceFormatter(
                                  findQuota?.coveredQty || "0",
                                  undefined,
                                  false,
                                  true,
                                )}{" "}
                                {product?.saleUOMTH})
                              </Text>
                            )}
                          </FlexCol>
                        ) : (
                          <FlexCol style={{ alignItems: "flex-end" }}>
                            <Text>-</Text>
                          </FlexCol>
                        )}
                      </>
                    ),
                  };
                },
              };
            }),
          },
        ]
      : []),
    ...(dynamicCoColumns.length > 0
      ? [
          {
            title: (
              <div style={{ textAlign: "center" }}>
                <Text fontWeight={600} color='white'>
                  รายการ CO ดูแลราคา (บาท)
                </Text>
              </div>
            ),
            onHeaderCell: () => ({
              style: {
                backgroundColor: "#F46363",
              },
            }),
            children: dynamicCoColumns.map((col: any) => ({
              title: (
                <div style={{ textAlign: "center" }}>
                  <Text fontWeight={600} color='white'>
                    {col.title}
                  </Text>
                </div>
              ),
              dataIndex: col.title,
              key: col.title,
              //width: "12%",
              onHeaderCell: () => ({
                style: {
                  backgroundColor: "#F46363",
                },
              }),
              render: (_value: string, product: any) => {
                const findCo = product.findCo?.find((c: any) => c.coName === col.title) || null;
                return {
                  children: findCo ? (
                    <FlexCol style={{ alignItems: "flex-end" }}>
                      <Text level={5} fontWeight={600} color='error'>
                        -{priceFormatter(findCo.amount || "0", undefined, false, true)}
                      </Text>
                      {product?.productName !== "Total" && (
                        <Text level={6} color='Text3'>
                          ({priceFormatter(findCo.unitAmount || "0", undefined, false, true)} บาท *{" "}
                          {priceFormatter(findCo.coveredQty || "0", undefined, false, true)}{" "}
                          {product?.saleUOMTH})
                        </Text>
                      )}
                    </FlexCol>
                  ) : (
                    <FlexCol style={{ alignItems: "flex-end" }}>
                      <Text>-</Text>
                    </FlexCol>
                  ),
                };
              },
            })),
          },
        ]
      : []),
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Text fontWeight={600}>ส่วนลดรวม</Text>
        </div>
      ),
      dataIndex: "totalDiscount",
      key: "totalDiscount",
      width: "10%",
      render: (value: number, product: any, index: number) => {
        return {
          children: (
            <>
              {value > 0 ? (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text color='error' fontWeight={600} level={5}>
                    -{priceFormatter(value || "0", undefined, false, true)}
                  </Text>
                  {product?.productName !== "Total" && (
                    <Text level={6} color='Text3'>
                      บาท
                    </Text>
                  )}
                </FlexCol>
              ) : (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text>-</Text>
                </FlexCol>
              )}
            </>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Row justify={"start"} gutter={16}>
        <Col>
          <Button
            title='หน้าหลัก'
            height={32}
            typeButton={orderTab === "main" ? "primary" : "primary-light"}
            onClick={() => setOrderTab("main")}
          />
        </Col>
        <Col>
          <Button
            title='Preview ก่อนเปิดคำสั่งซื้อ'
            height={32}
            typeButton={orderTab === "detail" ? "primary" : "primary-light"}
            onClick={() => setOrderTab("detail")}
          />
        </Col>
      </Row>
      <br />
      {orderTab === "main" && (
        <>
          <Row style={{ paddingBottom: 16 }}>
            <Col span={12}>
              <FlexRow align='center'>
                <Dropdown
                  menu={{
                    items: rawColumns
                      .filter((item, i) => i !== 0 && item.key !== "price")
                      .filter((c) => isShowPrice || !priceColumnKeys?.includes(c.key))
                      .map((item, i) => ({
                        key: item.key,
                        label: (
                          <FlexRow align='center'>
                            <Checkbox
                              checked={visibleColumns?.includes(item.key)}
                              onChange={(e) => {
                                updateVisibleColumn(e.target.checked, item.key);
                              }}
                            />
                            &nbsp;&nbsp;&nbsp;
                            <Text level={6} style={{ paddingTop: 2 }}>
                              {item.title}
                              {item.title2 || ""}
                            </Text>
                          </FlexRow>
                        ),
                      })),
                  }}
                  onOpenChange={(open) => {
                    console.log("onOpenChange", open);
                    // set colunm state
                  }}
                >
                  <AntdButton>
                    แสดงคอลัมน์&nbsp;
                    <DownOutlined />
                  </AntdButton>
                </Dropdown>
                &nbsp;&nbsp;&nbsp;
                <Text level={6}>ทั้งหมด&nbsp;{data?.orderProducts?.length || 0}&nbsp;รายการ</Text>
              </FlexRow>
            </Col>
            <Col span={12}>
              <div style={{ display: "flex", justifyContent: "end", paddingRight: 8, gap: 8 }}>
                <Image src={icons.ribbonBadgeBlue} preview={false} width={20} />{" "}
                <span>ของแถมโปรโมชั่น</span>
                <Image src={icons.ribbonBadgeRed} preview={false} width={20} />{" "}
                <span>ของแถม Special Request</span>
              </div>
            </Col>
          </Row>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  footerBg: "#EFF2F9",
                },
              },
            }}
          >
            <Table
              columns={columns}
              dataSource={
                data?.sort((a, b) =>
                  company === "ICPL"
                    ? ("" + (a.productCodeNAV || a.productFreebiesCodeNAV)).localeCompare(
                        b.productCodeNAV || b.productFreebiesCodeNAV || "",
                      )
                    : (a?.shipmentOrder || a?.shipmentOrder === 0 ? a?.shipmentOrder : 10000) -
                      (b?.shipmentOrder || b?.shipmentOrder === 0 ? b?.shipmentOrder : 10000),
                ) || []
              }
              rowKey='rowKey'
              {...(data?.some((item) => item.editCoList?.some(() => true)) && {
                expandable: {
                  expandedRowRender: (record: any) => {
                    const coList = record?.editCoList || [];
                    return (
                      <>
                        <Row>
                          <Text fontWeight={700}>
                            รายการส่วนลดที่สินค้าเข้าร่วม ({coList?.length || 0} รายการ)
                          </Text>
                        </Row>
                        <br />
                        {coList?.map((co, index) => {
                          return (
                            <div key={co?.coId} style={{ marginBottom: 16 }}>
                              <div
                                style={{
                                  borderLeft: `4px solid ${co?.creditMemoType?.color}`,
                                  padding: "8px",
                                  backgroundColor: "#EFF2F9",
                                }}
                              >
                                <Row justify='space-between' gutter={8} align='middle'>
                                  <Col>
                                    <Text fontWeight={600}>{co?.name}</Text>
                                    <br />
                                    <Text level={6} color='Text3'>
                                      {dayjs(co?.startDate).format("DD/MM/YYYY")} -{" "}
                                      {dayjs(co?.endDate).format("DD/MM/YYYY")} •
                                      ใช้ไป(คำสั่งซื้อนี้){" "}
                                      <Text
                                        color={co?.products?.totalDiscount > 0 ? "error" : "Text3"}
                                        level={6}
                                      >
                                        {co?.products?.totalDiscount > 0
                                          ? `-${numberFormatter(co?.products?.totalDiscount || 0)}`
                                          : 0}
                                      </Text>
                                    </Text>
                                  </Col>
                                  <Col>
                                    {(coList.filter((c) => c.type === "SKU")?.length > 0 ||
                                      editCoList.filter((c) => c.type === "SKU")?.length > 0) &&
                                      (statusOrder === "APPROVED_ORDER" ||
                                        statusOrder === "CONFIRM_ORDER" ||
                                        statusOrder === "APPROVE_SALE_ORDER") && (
                                        <AntdButton
                                          style={{
                                            color: color.primary,
                                            borderColor: color.primary,
                                          }}
                                          icon={<EditOutlined style={{ fontSize: 12 }} />}
                                          onClick={() =>
                                            startTransition(() => {
                                              navigate("/order/editDetail/" + data[0]?.orderId, {
                                                state: {
                                                  coData: editCoList.find(
                                                    (c) => c?.coId === co?.coId,
                                                  ),
                                                },
                                              });
                                            })
                                          }
                                        >
                                          แก้ไขส่วนลด
                                        </AntdButton>
                                      )}
                                  </Col>
                                </Row>
                              </div>
                              <ConfigProvider
                                theme={{
                                  components: {
                                    Table: {
                                      headerBg: "#EFF2F9",
                                      fontFamily: "IBM Plex Sans Thai",
                                      fontSize: 15,
                                      footerBg: "#EFF2F9",
                                    },
                                  },
                                }}
                              >
                                <Table
                                  size='small'
                                  columns={coColumns}
                                  dataSource={co?.products?.lines || []}
                                  tableLayout='fixed'
                                  pagination={false}
                                  footer={(dataFooter) => {
                                    const calculateTotalDiscount = dataFooter?.reduce(
                                      (acc, curr) => acc + (curr?.coDiscount || 0),
                                      0,
                                    );
                                    return (
                                      <>
                                        <Row style={{ justifyContent: "start" }} gutter={16}>
                                          <Col span={16}>
                                            <Text fontWeight={600}>
                                              รวม {co?.products?.orderQuantity || 0}{" "}
                                              {co?.products?.saleUOMTH || "-"}
                                            </Text>{" "}
                                          </Col>
                                          <Col>
                                            <Text
                                              fontWeight={600}
                                              color={calculateTotalDiscount > 0 ? "error" : "Text1"}
                                            >
                                              {calculateTotalDiscount > 0
                                                ? `-${numberFormatter(calculateTotalDiscount || 0)}`
                                                : numberFormatter(0)}{" "}
                                            </Text>{" "}
                                          </Col>
                                        </Row>
                                      </>
                                    );
                                  }}
                                />
                              </ConfigProvider>
                              <div style={{ marginTop: 8, marginBottom: 8 }}>
                                {co.latestAddRemark && (
                                  <Text level={6} fontWeight={600}>
                                    <ExclamationCircleOutlined /> หมายเหตุ (เพิ่มส่วนลด):{" "}
                                    <Text level={6}>{co.latestAddRemark}</Text>
                                  </Text>
                                )}
                                <br />
                                {co.latestEditRemark && (
                                  <Text level={6} fontWeight={600}>
                                    <ExclamationCircleOutlined /> หมายเหตุ (แก้ไขส่วนลด):{" "}
                                    <Text level={6}>{co.latestEditRemark}</Text>
                                  </Text>
                                )}
                              </div>
                              <Divider size='small' />
                            </div>
                          );
                        })}
                      </>
                    );
                  },
                  expandIcon: ({
                    expanded,
                    onExpand,
                    record,
                  }: {
                    expanded: boolean;
                    onExpand: any;
                    record: any;
                  }) => {
                    const splitRowKey = record.rowKey?.split("-");
                    let newExpanded = record;
                    if (splitRowKey.length > 2) {
                      newExpanded =
                        data?.find(
                          (d) => d.rowKey === `${splitRowKey[0]}-${splitRowKey[1]}-${2}`,
                        ) || record;
                    }
                    if (
                      !record?.editCoList ||
                      record?.editCoList?.length === 0 ||
                      record?.isFreebie
                    )
                      return null;

                    return expanded ? (
                      <UpOutlined onClick={(event) => onExpand(newExpanded, event)} />
                    ) : (
                      <DownOutlined onClick={(event) => onExpand(newExpanded, event)} />
                    );
                  },
                },
              })}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </ConfigProvider>
          {/* <Table
        columns={columns}
        dataSource={
          data?.sort((a, b) =>
            company === "ICPL"
              ? ("" + (a.productCodeNAV || a.productFreebiesCodeNAV)).localeCompare(
                  b.productCodeNAV || b.productFreebiesCodeNAV || "",
                )
              : (a?.shipmentOrder || a?.shipmentOrder === 0 ? a?.shipmentOrder : 10000) -
                (b?.shipmentOrder || b?.shipmentOrder === 0 ? b?.shipmentOrder : 10000),
          ) || []
        }
        pagination={false}
        scroll={{ x: "max-content" }}
      /> */}
        </>
      )}
      {orderTab === "detail" && (
        <>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#F3F6F9",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                },
              },
            }}
          >
            <StyledTable
              size='small'
              columns={orderDiscountColumes}
              dataSource={orderDiscount}
              pagination={false}
              scroll={{
                x: `${
                  Math.max(
                    2 +
                      Number(dynamicCoColumns.length) +
                      Number(dynamicPromotionColumns.length) +
                      Number(dynamicQuotaColumns.length),
                  ) * 300
                }px`,
              }}
              bordered
              rowClassName={(record: any) => (record.productName === "Total" ? "total-row" : "")}
            />
          </ConfigProvider>
        </>
      )}
    </>
  );
};

export const TabShipment = ({ orderData }: { orderData: any }) => {
  const shipmentColume = [
    {
      title: "ประเภทรถ",
      dataIndex: "truckType",
      key: "truckType",
      render: (value: string, row: any, index: number) => {
        const mapTruck: any = {
          FRONT_TRUCK: "รถแม่",
          REAR_TRUCK: "รถลูก",
        };
        return {
          children: (
            <FlexRow align='center'>
              {row?.deliveryNo === 1 && (
                <div
                  style={{
                    border: "solid, #F3F6F9",
                    width: "85px",
                    height: "32px",
                    paddingTop: "5px",
                    paddingLeft: "6px",
                    borderRadius: "7px",
                    backgroundColor: "#F3F6F9",
                  }}
                >
                  <img src={value === "FRONT_TRUCK" ? icons.iconFrontTruck : icons.iconRearTruck} />{" "}
                  <Text level={5} fontWeight={600}>
                    {mapTruck[value]}
                  </Text>
                </div>
              )}
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ลำดับการขน",
      dataIndex: "deliveryNo",
      key: "deliveryNo",
      render: (value: string, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สินค้า",
      dataIndex: "productName",
      key: "productName",
      render: (value: string, row: any, index: number) => {
        const findImg = orderData?.orderProducts?.find((x) => x.productId === row.productId);
        return {
          children: (
            <FlexRow align='center'>
              <div style={{ marginRight: 16 }}>
                <Image
                  src={findImg?.productImage || image.product_no_image}
                  style={{
                    width: "55px",
                    height: "55px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <Text level={5}>{value}</Text>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "จำนวน",
      dataIndex: "quantity",
      key: "quantity",
      render: (value: string, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>
                {Number(value).toFixed(2)} {row.unit}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <Table
      columns={shipmentColume}
      dataSource={
        orderData?.orderLoads
          ?.sort((i: any, j: any) => i?.deliveryNo - j?.deliveryNo)
          ?.sort((a: any, b: any) => a?.truckType.localeCompare(b?.truckType)) || []
      }
      pagination={false}
      scroll={{ x: "max-content" }}
    />
  );
};

export const TabPending = ({ orderData, company }: { orderData: any; company: string }) => {
  const [pendingNoteDate, setPendingNoteDate] = useState<string>("");
  const [modalNotePending, setModalNotePending] = useState<boolean>(false);
  const [pendingNote, setPendingNote] = useState<string>("");

  const shipmentPendingColumn = [
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      width: 360,
      render: (productName: string, product: ProductEntity, index: number) => {
        return {
          children: (
            <>
              <FlexRow align='center'>
                <div style={{ marginRight: 16 }}>
                  <Image
                    src={product?.productImage || image.product_no_image}
                    style={{
                      width: "55px",
                      height: "55px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <FlexCol>
                  <Text level={5}>{productName}</Text>
                  <Text level={6} color='Text3'>
                    {product?.commonName}
                  </Text>
                </FlexCol>
              </FlexRow>
            </>
          ),
        };
      },
    },
    {
      title: "ขนาด",
      dataIndex: "packSize",
      key: "packSize",
      width: 170,
      render: (packSize: string, product: ProductEntity, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>{packSize}</Text>
              <Text level={6} color='Text3'>
                {product?.productCodeNAV || product?.productFreebiesCodeNAV}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "จำนวนที่สั่งซื้อ",
      dataIndex: "quantity",
      key: "quantity",
      width: 125,
      render: (quantity: string, product: ProductEntity, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5}>{Number(quantity)}</Text>
              <Text level={6} color='Text3'>
                {product?.baseUnitOfMeaTh || product?.saleUOMTH || product?.saleUOM}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ค้างส่ง",
      dataIndex: "qtyOutstanding",
      key: "qtyOutstanding",
      width: 160,
      render: (qtyOutstanding: number, product: ProductEntity, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5} color={Number(qtyOutstanding) > 0 ? "warning" : "BK"}>
                {Number(qtyOutstanding || "0")}
              </Text>
              <Text level={6} color='Text3'>
                {product?.saleUOMTH || product?.saleUOM || product?.saleUom || "หน่วย"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ส่งแล้ว",
      dataIndex: "qtyShip",
      key: "qtyShip",
      width: 160,
      render: (qtyShip: any[], product: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text level={5} color={Number(qtyShip) > 0 ? "success" : "BK"}>
                {Number(qtyShip || "0")}
              </Text>
              <Text level={6} color='Text3'>
                {product?.saleUOMTH || product?.saleUOM || product?.saleUom || "หน่วย"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ยกเลิก",
      dataIndex: "isCancel",
      key: "isCancel",
      width: 160,
      render: (qtyOutstanding: any[], product: any, index: number) => {
        const calQty =
          product?.isCancel && product?.qtyOutstanding == 0
            ? product?.quantity - product.qtyShip
            : 0;
        return {
          children: (
            <>
              {product?.isFreebie && !product?.isSpecialRequestFreebie && (
                <div style={{ position: "relative", bottom: 26, right: -10 }}>
                  <Badge.Ribbon text='ของแถม' placement='end' />
                </div>
              )}
              {product?.isFreebie && product?.isSpecialRequestFreebie && (
                <div style={{ position: "relative", bottom: 26, right: -10 }}>
                  <Badge.Ribbon text='ของแถม' placement='end' color={color.error} />
                </div>
              )}
              <FlexCol>
                <Row>
                  <Text level={5} color={Number(calQty) > 0 ? "error" : "BK"}>
                    {Number(calQty || "0")}
                  </Text>
                  {product?.note && (
                    <>
                      &nbsp;
                      <PendingNoteTag
                        onClick={() => {
                          setPendingNoteDate(product?.finishOrderLineDate || "");
                          setPendingNote(product?.note || "");
                          setModalNotePending(true);
                        }}
                      />
                    </>
                  )}
                </Row>
                <Text level={6} color='Text3'>
                  {product?.saleUOMTH || product?.saleUOM || product?.saleUom || "หน่วย"}
                </Text>
              </FlexCol>
            </>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Row style={{ paddingBottom: 16 }}>
        <Col span={12}>
          <FlexRow align='center'>
            <Text level={6}>ทั้งหมด&nbsp;{orderData?.orderProducts?.length || 0}&nbsp;รายการ</Text>
          </FlexRow>
        </Col>
        <Col span={12}>
          <div style={{ display: "flex", justifyContent: "end", paddingRight: 8, gap: 8 }}>
            <Image src={icons.ribbonBadgeBlue} preview={false} width={20} />{" "}
            <span>ของแถมโปรโมชั่น</span>
            <Image src={icons.ribbonBadgeRed} preview={false} width={20} />{" "}
            <span>ของแถม Special Request</span>
          </div>
        </Col>
      </Row>
      <Table
        columns={shipmentPendingColumn}
        dataSource={
          orderData?.orderPending?.sort((a, b) =>
            company === "ICPL"
              ? ("" + (a.productCodeNAV || a.productFreebiesCodeNAV)).localeCompare(
                  b.productCodeNAV || b.productFreebiesCodeNAV || "",
                )
              : (a?.shipmentOrder || a?.shipmentOrder === 0 ? a?.shipmentOrder : 10000) -
                (b?.shipmentOrder || b?.shipmentOrder === 0 ? b?.shipmentOrder : 10000),
          ) || []
        }
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {modalNotePending && (
        <Modal
          open={modalNotePending}
          footer={false}
          closable={false}
          width={420}
          onCancel={() => setModalNotePending(false)}
          centered
        >
          <Row justify={"space-between"}>
            <Col>
              <Text level={4} fontWeight={700}>
                เหตุผลที่ยกเลิก
              </Text>
            </Col>
            <Col>
              <Text level={6} fontWeight={400}>
                {pendingNoteDate ? dayjs(pendingNoteDate).locale("th").format(DATE_FORMAT) : ""}
              </Text>
            </Col>
          </Row>
          <br />
          <TextArea
            rows={6}
            placeholder='โปรดระบุเหตุผล...'
            disabled
            value={pendingNote}
            style={{ color: color.BK }}
          />
          <br />
          <br />
          <Row gutter={16} justify={"end"}>
            <Col span={24}>
              <Button
                title='ปิด'
                typeButton={"primary"}
                onClick={() => {
                  setModalNotePending(false);
                  setPendingNote("");
                }}
              />
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};

export const TabInvoice = ({ invoices, company }: { invoices: any; company: string }) => {
  const invoiceColume = [
    {
      title: "Invoice No.",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
      render: (invoiceNo: string, row: any) => {
        return (
          <FlexCol>
            <Text>{invoiceNo}</Text>
            <Text color='Text3' level={6}>
              {dayjs(row?.orderDate).format(datePattern)}
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "วันกำหนดชำระ",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (dueDate: string, row: any) => {
        return (
          <FlexCol>
            <Text>{dayjs(dueDate).format(datePattern)}</Text>
          </FlexCol>
        );
      },
    },
    {
      title: "เกินกำหนด (วัน)",
      dataIndex: "dueDate",
      key: "overdue",
      onlyWaitng: true,
      render: (dueDate: string, row: any) => {
        const overdue = dayjs(dueDate).diff(dayjs(), "days") * -1;
        return (
          <FlexCol>
            {row.paymentStatus === "ALREADY_PAID" ? (
              <Text color={"Text1"}>-</Text>
            ) : (
              <Text color={overdue >= 0 ? "error" : "Text1"}>
                {overdue >= 0 ? overdue : 0}&nbsp;วัน
              </Text>
            )}
          </FlexCol>
        );
      },
    },
    {
      title: "ยอดรวม",
      dataIndex: "amt",
      key: "amt",
      render: (amt: number, row: any) => {
        return (
          <FlexCol>
            <Text>{numberFormatter(amt, 2)}</Text>
            <Text color='Text3' level={6}>
              บาท
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "PDC",
      dataIndex: "invoicePayments",
      key: "pdc",
      render: (invoicePayments: any, row: any) => {
        const sumPdc = invoicePayments?.reduce(
          (acc, inv) => (inv.paymentChannel?.includes("เช็ค") ? acc + inv?.rvAmt : acc),
          0,
        );
        return (
          <FlexCol>
            <Text>{numberFormatter(sumPdc, 2)}</Text>
            <Text color='Text3' level={6}>
              บาท
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "เงินโอน",
      dataIndex: "invoicePayments",
      key: "cod",
      render: (invoicePayments: any, row: any) => {
        const sumPdc = invoicePayments?.reduce(
          (acc, inv) => (inv.paymentChannel?.includes("เงินโอน") ? acc + inv?.rvAmt : acc),
          0,
        );
        return (
          <FlexCol>
            <Text>{numberFormatter(sumPdc, 2)}</Text>
            <Text color='Text3' level={6}>
              บาท
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "ชำระอื่นๆ",
      dataIndex: "invoicePayments",
      key: "other",
      render: (invoicePayments: any, row: any) => {
        const sumPdc = invoicePayments?.reduce(
          (acc, inv) =>
            !inv.paymentChannel?.includes("เงินโอน") && !inv?.paymentChannel?.includes("เช็ค")
              ? acc + inv?.rvAmt
              : acc,
          0,
        );
        return (
          <FlexCol>
            <Text>{numberFormatter(sumPdc, 2)}</Text>
            <Text color='Text3' level={6}>
              บาท
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "ยอดคงเหลือ",
      dataIndex: "invoicePayments",
      key: "sum",
      onlyPaid: true,
      render: (invoicePayments: any, row: any) => {
        const sumPym = invoicePayments?.reduce((acc, inv) => acc + inv?.rvAmt, 0);
        return (
          <FlexCol>
            <Text>{numberFormatter(invoicePayments[0]?.ivAmt - sumPym, 2)}</Text>
            <Text color='Text3' level={6}>
              บาท
            </Text>
          </FlexCol>
        );
      },
    },
    {
      title: "สถานะ",
      dataIndex: "paymentStatus",
      key: "status",
      render: (status: string, row: any) => {
        // const sumPym =
        //   row?.invoicePayments[0]?.ivAmt -
        //   row?.invoicePayments?.reduce((acc, inv) => acc + inv?.rvAmt, 0);
        // const mapStatus = sumPym ? "PARTIAL_PAYMENT" : status;
        return (
          <FlexCol>
            <Tag color={orderSubStatusColor[status]} style={{ borderRadius: 12 }}>
              <Text color='white' fontWeight={600} fontSize={14}>
                {orderSubStatusLabel[status]}
              </Text>
            </Tag>
          </FlexCol>
        );
      },
    },
    {
      title: "",
      dataIndex: "invoiceNo",
      key: "download",
      render: (invNo: string) => {
        const onDownload = async () => {
          const token = localStorage.getItem("token") || "";
          const headers = {
            "Content-Type": "blob",
            Authorization: token ? `Bearer ` + JSON.parse(token) : "",
          };
          const config: AxiosRequestConfig = {
            method: "GET",
            url: `https://system.icpladda.com/api/invoice/download?invNo=${invNo}&company=${company}`,
            responseType: "arraybuffer",
            headers,
            params: { invNo, company },
          };
          const response = await axios(config);

          const file = new Blob([response.data], {
            type: "application/pdf",
          });

          const url = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `invoice-${invNo}-${new Date().toISOString().split("T")[0]}.pdf`,
          );

          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
        };
        return (
          <>
            {!invNo.startsWith("JV") && (
              <div
                className='btn btn-icon btn-light btn-hover-primary btn-sm'
                onClick={onDownload}
                style={{ cursor: "pointer" }}
              >
                <span className='svg-icon svg-icon-primary svg-icon-2x'>
                  {<img src={icons.downloadFileIcon} style={{ width: 15, height: 16 }} />}
                </span>
              </div>
            )}
          </>
        );
      },
    },
  ];
  return (
    <Table
      columns={invoiceColume}
      dataSource={invoices || []}
      pagination={false}
      scroll={{ x: "max-content" }}
    />
  );
};

export const FooterTab = ({ orderData }: { orderData: any }) => {
  const mapTotalUnit = () => {
    let subObj: any = [];
    const g = _.groupBy(
      orderData?.orderProducts || [],
      (item) => item.baseUnitOfMeaTh || item.saleUOMTH,
    );
    const obj = _.map(g, (items, unit) => {
      if (unit === "null") {
        const subGroup = _.groupBy(g[unit] || [], "saleUOMTH");
        subObj = _.map(subGroup, (sub, subUnit) => {
          const subMap = `${sub
            .reduce((x, { quantity }, i) => x + Number(quantity), 0)
            .toFixed(2)} ${subGroup[subUnit][0].saleUOMTH}`;
          return subMap;
        });
      } else {
        const map = `${items.reduce((x, { quantity }, i) => x + Number(quantity), 0).toFixed(2)} ${
          g[unit][0].baseUnitOfMeaTh || g[unit][0].saleUOMTH
        }`;
        return map;
      }
    });
    return [...subObj, ...obj].filter((x) => !!x).join(", ");
  };

  return (
    <>
      <Row justify={"space-between"}>
        <Col span={12}>
          <Text fontWeight={600}>สรุปจำนวนทั้งหมด</Text>
        </Col>
      </Row>
      <div style={{ borderRadius: "8px", backgroundColor: color.background1, padding: "10px" }}>
        <Row justify={"space-between"}>
          <Col span={12}>
            <DetailItem
              label='รายการทั้งหมด :'
              value={`${orderData?.orderProducts?.length} รายการ`}
            />
            <DetailItem
              label='รายการของแถม :'
              value={`${orderData?.orderProducts?.filter((p) => p?.isFreebie).length} รายการ`}
            />
          </Col>
          <Col span={12}>
            <DetailItem
              label='จำนวนสินค้าทั้งหมด'
              labelEn='รวมของแถม'
              value={
                <Text fontWeight={600} fontSize={20}>
                  {mapTotalUnit()}
                </Text>
              }
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export const SoApprove = ({
  showApproveSoModal,
  setShowApproveSoModal,
  form,
  orderId,
}: {
  showApproveSoModal: any;
  setShowApproveSoModal: any;
  form: any;
  orderId: string;
}) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const navigate = useNavigate();
  const reasonApproveSo = Form.useWatch("reasonApproveSo", form);
  const [updating, setUpdating] = useState(false);

  const onSubmitApproveSo = async (action: string) => {
    setUpdating(true);
    await approveSoOrder({
      orderId,
      userStaffId: userProfile.userStaffId,
      action,
      updateBy: `${userProfile.firstname} ${userProfile.lastname}`,
      reason: reasonApproveSo,
    })
      .then((res: any) => {
        form.resetFields(["reasonApproveSo"]);
        navigate(0);
      })
      .catch((e: any) => {
        throw e;
      })
      .finally(() => {
        setUpdating(false);
      });
  };
  return (
    <>
      <CardContainer>
        <Row gutter={16} align='middle' justify='end'>
          <Col span={3}>
            <Row justify='end'>
              <Text>จัดการใบสั่งขาย :</Text>
            </Row>
          </Col>
          <Col span={3}>
            <Button
              title='ไม่อนุมัติ'
              typeButton='danger'
              onClick={() => setShowApproveSoModal({ modal: true, action: "REJECT" })}
              // onClick={() => updateStatus("REJECT_ORDER")}
            />
          </Col>
          <Col span={3}>
            <Button
              title='อนุมัติ'
              typeButton='primary'
              onClick={() => setShowApproveSoModal({ modal: true, action: "APPROVE" })}
            />
          </Col>
        </Row>
      </CardContainer>
      {showApproveSoModal.modal && (
        <Modal open={showApproveSoModal.modal} footer={false} closable={false} width={420}>
          <FlexCol>
            <Text level={4} fontWeight={700}>
              ยืนยันการอนุมัติใบสั่งขาย
            </Text>
            <br />
          </FlexCol>
          <Form form={form}>
            <Form.Item noStyle name='reasonApproveSo'>
              <TextArea rows={6} placeholder='ระบุเหตุผล' />
            </Form.Item>
          </Form>
          <Divider />
          <Row gutter={16} justify={"end"}>
            <Col span={6}>
              <Button
                size='small'
                title='ยกเลิก'
                typeButton='primary-light'
                style={{
                  width: "100%",
                  height: "32px",
                  lineHeight: "32px",
                  padding: "0 16px",
                }}
                onClick={() => {
                  setShowApproveSoModal({ modal: false, action: "" });
                  form.resetFields(["reasonApproveSo"]);
                }}
              />
            </Col>
            <Col span={6}>
              <Button
                size='small'
                title='ยืนยัน'
                typeButton={
                  showApproveSoModal.action == "REJECT" && !reasonApproveSo ? "disabled" : "primary"
                }
                style={{
                  width: "100%",
                  height: "32px",
                  lineHeight: "32px",
                  padding: "0 16px",
                }}
                loading={updating}
                disabled={updating || (showApproveSoModal.action == "REJECT" && !reasonApproveSo)}
                onClick={() => {
                  !updating && !(showApproveSoModal.action == "REJECT" && !reasonApproveSo)
                    ? onSubmitApproveSo(showApproveSoModal.action)
                    : null;
                }}
              />
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};

export const AddCoListModal = ({
  open,
  onCancel,
  orderId,
  editCoList,
  fetchData,
}: {
  open: { open: boolean; key: number; value: string };
  onCancel: () => void;
  orderId: string;
  editCoList: any;
  fetchData: () => void;
}) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { messageApi } = useMessageContext();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [coList, setCoList] = useState<any[]>([]);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchCoAvalibleList = async () => {
    await getCoAvailableById(orderId).then((res) => {
      const mapChecked = (res.cos || []).map((co: any) => {
        return { ...co, checked: false };
      });
      setCoList(mapChecked.filter((co) => co.type === "SKU") || []);
    });
  };

  useEffect(() => {
    setLoading(true);
    if (open.key === 1) {
      fetchCoAvalibleList();
    } else {
      setCoList(editCoList.filter((co) => co.type === "SKU"));
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [orderId, open.open]);

  const onSubmit = async () => {
    const selectedCo = coList.filter((co) => co.checked);
    try {
      await form.validateFields();
      setModalConfirm(false);
      if (selectedCo) {
        await addOrderCo({
          params: {
            coIds: selectedCo.map((co) => co.coId),
            remark: form.getFieldValue("remark") || "",
          },
          orderId,
          updateBy: userProfile.firstname + " " + userProfile.lastname,
        }).then((res) => {
          if (res.success) {
            messageApi.success("บันทึกสำเร็จ");
            onCancel();
            fetchData();
          }
        });
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  const columns = [
    {
      title: coList?.length > 0 && (
        <Checkbox
          checked={coList.every((co) => co.checked)}
          onChange={(e) => {
            const checked = e.target.checked;
            setCoList(coList.map((co) => ({ ...co, checked })));
          }}
        />
      ),
      dataIndex: "checked",
      key: "checked",
      hidden: open.key === 1 ? false : true,
      render: (value: any, record: any) => {
        return (
          <>
            <Checkbox
              checked={record.checked}
              onChange={(e) => {
                const checked = e.target.checked;
                setCoList(coList.map((co) => (co.coId === record.coId ? { ...co, checked } : co)));
              }}
            />
          </>
        );
      },
    },
    {
      title: "รหัสส่วนลด",
      dataIndex: "code",
      key: "code",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ชื่อรายการ",
      dataIndex: "name",
      key: "name",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text level={6} color='Text3'>
                {row?.shopCount} ร้านค้า{" "}
                {row?.productCount > 0 ? `• ${row?.productCount} สินค้า` : ""}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ประเภทส่วนลด",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Tag style={{ backgroundColor: `${row?.creditMemoType?.color}20`, border: "none" }}>
                <Typography.Text
                  style={{
                    color: row?.creditMemoType?.color,
                    fontFamily: "IBM Plex Sans Thai",
                    fontSize: 15,
                    fontWeight: "bold",
                  }}
                >
                  {row?.creditMemoType?.code} • {row?.creditMemoType?.nameTh}
                </Typography.Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "วิธีคิดส่วนลด",
      dataIndex: "type",
      key: "type",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value === "SKU" ? "บาท (฿) / หน่วย" : "% ของยอดบิล"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ระยะเวลา",
      dataIndex: "startDate",
      key: "startDate",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>
                {dayjs(row?.startDate).format("DD/MM/YYYY")} -{" "}
                {dayjs(row?.endDate).format("DD/MM/YYYY")}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ส่วนลดรวม",
      dataIndex: "quotaAmount",
      key: "quotaAmount",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ใช้ไป",
      dataIndex: "quotaUsed",
      key: "quotaUsed",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "error" : "Text1"}>
                {value > 0 ? `-${numberFormatter(value)}` : numberFormatter(value)} ฿
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "คงเหลือ",
      dataIndex: "quotaRemaining",
      key: "quotaRemaining",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "EmeraldGreen" : "Text1"}>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "แสดงให้ Dealer",
      dataIndex: "visibleToDealer",
      key: "visibleToDealer",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Tag
                style={{
                  backgroundColor: value ? "#E2FDEB" : "#F3F6F9",
                  border: "none",
                }}
              >
                <Text color={value ? "EmeraldGreen" : "Disable"} level={6} fontWeight={600}>
                  {value ? "แสดง" : "ไ่ม่แสดง"}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      width: 80,
      hidden: open.key === 1 ? true : false,
      fixed: "right" as FixedType | undefined,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"space-between"} gutter={8}>
              <Col>
                <ActionBtn
                  onClick={() =>
                    startTransition(() => {
                      navigate("/order/editDetail/" + orderId, {
                        state: {
                          coData: row,
                        },
                      });
                    })
                  }
                  icon={<FormOutlined />}
                />
              </Col>
            </Row>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Modal
        open={open.open}
        onCancel={onCancel}
        centered
        maskClosable={false}
        width={1050}
        footer={
          open.key === 2 ? null : (
            <Row justify='end'>
              <AntdButton
                type='primary'
                style={{
                  backgroundColor:
                    coList.filter((co) => co.checked).length > 0 ? "#1890ff" : color.Disable,
                  border: "none",
                }}
                onClick={() => {
                  coList.filter((co) => co.checked).length > 0 && setModalConfirm(true);
                }}
              >
                {`เพิ่มส่วนลด${coList.filter((co) => co.checked).length > 0 ? ` ${coList.filter((co) => co.checked).length} รายการ` : ""}`}
              </AntdButton>
            </Row>
          )
        }
      >
        <Row>
          <Text level={4} fontWeight={600}>
            {open.value}
          </Text>
        </Row>
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#F3F6F9",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
              },
            },
          }}
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={coList || []}
            pagination={false}
            scroll={{ x: "max-content", y: 420 }}
          />
        </ConfigProvider>
      </Modal>
      {modalConfirm && (
        <Modal
          open={modalConfirm}
          onCancel={() => setModalConfirm(false)}
          onOk={() => {
            onSubmit();
          }}
          width={630}
          cancelButtonProps={{ style: { display: "none" } }}
          centered
          maskClosable={false}
        >
          <Col>
            <Text level={3} fontWeight={600}>
              เพิ่มรายการส่วนลด
            </Text>
          </Col>
          <Col>
            <Text color='Text3'>
              โปรดยืนยันการเพิ่มรายการส่วนลด เมื่อเพิ่มส่วนลดแล้วจะไม่สามารถนำออกได้ในภายหลัง
            </Text>
          </Col>
          <Form form={form} layout='vertical'>
            <Form.Item
              label='หมายเหตุเพิ่มส่วนลด'
              name='remark'
              rules={[
                {
                  required: userProfile.company === "ICPL",
                  message: "กรุณาระบุหมายเหตุเพิ่มส่วนลด",
                },
              ]}
            >
              <Input
                placeholder='ระบุหมายเหตุเพิ่มส่วนลด'
                style={{ height: "40px", width: "100%" }}
                autoComplete='off'
              />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export const ModalEditPctCo = ({
  open,
  onCancel,
  data,
  orderData,
  fetchData,
  action,
}: {
  open: boolean;
  onCancel: () => void;
  data: any;
  orderData: any;
  fetchData: () => void;
  action?: any;
}) => {
  const { messageApi } = useMessageContext();
  const [form] = Form.useForm();
  const watchPercent = Form.useWatch("percent", form);
  const [show, setShow] = useState(false);
  const [detailDiscount, setDetailDiscount] = useState<any>(null);
  const [isSkeleton, setIsSkeleton] = useState(false);

  useEffectOnce(() =>
    form.setFieldsValue({
      percent: data?.billPct?.discountValue || data?.discountValue,
      masterPercent: data?.billPct?.discountValue || data?.discountValue,
      oldPercent: data?.billPct?.discountValue || data?.discountValue,
    }),
  );

  const fetchCal = async (percent?: number) => {
    await previewCoPercent({
      orderId: orderData.orderId,
      coId: data.coId,
      pct:
        percent !== undefined
          ? Number(percent)
          : data?.billPct?.discountValue || data?.discountValue,
    }).then((res) => {
      const mapDiscount = {
        price: res?.summary?.price || 0,
        promotionDiscount: res?.summary?.promotionDiscount || 0,
        specialRequestDiscount: res?.summary?.specialRequestDiscount || 0,
        quotaDiscount: res?.summary?.quotaDiscount || 0,
        cashDiscount: res?.summary?.cashDiscount || 0,
        coDiscount: (res?.summary?.billCoDiscount || 0) + (res?.summary?.skuCoDiscount || 0),
        totalDiscount: res?.summary?.totalDiscount || 0,
        totalPrice: res?.summary?.totalPrice || 0,
        totalPriceNoVat: res?.summary?.totalPriceNoVat || 0,
        skuCoDiscount: res?.summary?.skuCoDiscount || 0,
        pct: res?.pct || 0,
        billCoDiscount: res?.summary?.billCoDiscount || 0,
        orderProducts: orderData?.orderProducts,
      };
      setDetailDiscount(mapDiscount);
      form.setFieldValue(
        "oldPercent",
        percent !== undefined ? Number(percent) : data?.billPct?.discountValue,
      );
      setTimeout(() => {
        setIsSkeleton(false);
      }, 450);
    });
  };

  useEffect(() => {
    fetchCal();
  }, []);

  const checkValidate = () => {
    return (
      `${form.getFieldValue("masterPercent")}` !== `${form.getFieldValue("percent")}` &&
      `${form.getFieldValue("percent")}` !== "" &&
      `${form.getFieldValue("percent")}` !== undefined
    );
  };

  const onSubmit = async () => {
    try {
      await form.validateFields();
      await updateCoPercent({
        orderId: orderData.orderId,
        coId: data.coId,
        pct: Number(form.getFieldValue("percent")),
        remark: form.getFieldValue("remark"),
      }).then((res) => {
        if (res.success) {
          onCancel();
          messageApi.success("บันทึกสำเร็จ");
          fetchData();
        }
      });
    } catch (e) {
      console.log("error", e);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      centered
      width={600}
      cancelButtonProps={{ style: { display: "none" } }}
      maskClosable={false}
      footer={
        <Row justify={"end"} gutter={8}>
          <Col>
            <Button
              title='บันทึก'
              typeButton={
                action === "edit" ? (checkValidate() ? "primary" : "disabled") : "primary"
              }
              onClick={() => (action === "edit" ? checkValidate() && onSubmit() : onSubmit())}
            />
          </Col>
        </Row>
      }
    >
      <Text level={4} fontWeight={500}>
        {action === "edit" ? "แก้ไข" : "เพิ่ม"}ส่วนลด % ของยอดบิล
      </Text>
      <br />
      <Text color='Text3'>รายการส่วนลด : {data.name} • คงเหลือ</Text>{" "}
      <Text color={data.quotaRemaining > 0 ? "EmeraldGreen" : "Text1"}>
        {numberFormatter(data.quotaRemaining)}
      </Text>
      <Form form={form} layout='vertical'>
        <Row gutter={8}>
          <Col span={18}>
            <Form.Item
              name='percent'
              label='% ส่วนลด'
              required
              rules={[
                { required: true, message: "กรุณาระบุ % ส่วนลด" },
                {
                  validator: (_, value) => {
                    if (value > 100) {
                      return Promise.reject(new Error("ส่วนลดเกิน 100%"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                style={{ height: 40, width: "100%" }}
                suffix='%'
                autoComplete='off'
                onKeyDown={onInputNumberKeyPress}
              />
            </Form.Item>
          </Col>
          <Col span={6} style={{ paddingTop: "21px" }}>
            <Button
              onClick={() => {
                `${form.getFieldValue("oldPercent")}` !== `${form.getFieldValue("percent")}` &&
                  `${form.getFieldValue("percent")}` !== "" &&
                  `${form.getFieldValue("percent")}` !== undefined &&
                  Number(`${form.getFieldValue("percent")}`) <= 100 &&
                  (fetchCal(form.getFieldValue("percent")), setIsSkeleton(true));
              }}
              title={
                isSkeleton ? (
                  <>
                    <LoadingOutlined /> กำลังคำนวณ
                  </>
                ) : (
                  "ยืนยันค่า"
                )
              }
              typeButton={
                `${form.getFieldValue("oldPercent")}` !== `${form.getFieldValue("percent")}` &&
                `${form.getFieldValue("percent")}` !== "" &&
                `${form.getFieldValue("percent")}` !== undefined &&
                Number(`${form.getFieldValue("percent")}`) <= 100
                  ? "primary-light"
                  : "disabled"
              }
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label='หมายเหตุการแก้ไข'
              name='remark'
              rules={[
                { required: orderData.company === "ICPL", message: "กรุณาระบุหมายเหตุการแก้ไข" },
              ]}
            >
              <Input
                placeholder='ระบุหมายเหตุการแก้ไข'
                style={{ height: "40px", width: "100%" }}
                autoComplete='off'
              />
            </Form.Item>
          </Col>
        </Row>
        <DetailBox>
          <DetailItem
            label='ราคาก่อนลด'
            value={priceFormatter(detailDiscount?.price || "0", undefined, true)}
            alignRight
            fontWeight={700}
            fontSize={18}
            leftSpan={10}
            isSkeleton={isSkeleton}
          />
          <Row justify={"start"} gutter={8} style={{ paddingLeft: "8px" }}>
            <Col>
              <Text fontWeight={700} fontSize={18}>
                รายละเอียดส่วนลด
              </Text>
            </Col>
            <div style={{ paddingTop: "4px", cursor: "pointer" }} onClick={() => setShow(!show)}>
              {show ? <UpOutlined /> : <DownOutlined />}
            </div>
          </Row>
          {show && <DetailDiscount orderData={detailDiscount} scroll isSkeleton={isSkeleton} />}
          <DetailItem
            label='รวมส่วนลดสุทธิ'
            value={priceFormatter(detailDiscount?.totalDiscount || "0", undefined, true)}
            fontWeight={700}
            fontSize={18}
            alignRight
            leftSpan={10}
            isSkeleton={isSkeleton}
          />
          <DetailItem
            label={`มูลค่ารวมหลังหักส่วนลด`}
            value={priceFormatter(detailDiscount?.totalPrice || "0", undefined, true)}
            fontWeight={700}
            fontSize={18}
            alignRight
            leftSpan={10}
            isSkeleton={isSkeleton}
          />
          {!!orderData?.vat && orderData?.vat > 0 && (
            <DetailItem
              label={`ภาษีมูลค่าเพิ่ม ${orderData?.vatPercentage}%`}
              value={priceFormatter(orderData?.vat || "0", undefined, true)}
              fontWeight={700}
              fontSize={18}
              alignRight
              leftSpan={10}
              isSkeleton={isSkeleton}
            />
          )}
          <Divider size='small' />
          <DetailItem
            label='ราคารวม'
            value={
              <Text color='primary' fontWeight={700} fontSize={28}>
                {priceFormatter(detailDiscount?.totalPriceNoVat || "0", undefined, true)}
              </Text>
            }
            fontWeight={700}
            fontSize={24}
            alignRight
            leftSpan={10}
            isSkeleton={isSkeleton}
          />
        </DetailBox>
      </Form>
    </Modal>
  );
};
